import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Card from "react-bootstrap/Card";
import HeadingBanner from "../components/HeadingBanner";
import LeftPanel from "../components/LeftPanel";
import {
  whoami,
  getClasses,
  getCountryGrades,
  getCountryId,
  shareClass,
  updateClassOwnerId,
  postLastLogin,
  getLastLogin
} from "../services/APIClient";
import { Container, Row, Col, Form } from "react-bootstrap";
import "../components/ClassCard.css";
import "../components/MasterDashCards.css";
import OrientationPrompt from "../components/OrientationPrompt";
import TeacherResetTasksModal from "../components/TeacherResetTasksModal";
import TeacherAddChildModal from "../components/TeacherAddChildModal";
import TeacherRemoveChildModal from "../components/TeacherRemoveChildModal";
import TeacherCreateClassModal from "../components/TeacherCreateClassModal";
import TeacherRemoveClassModal from "../components/TeacherRemoveClassModal";
import TeacherRequestAccessModal from "../components/TeacherRequestAccessModal";
import TeacherSwapResultsModal from "../components/TeacherSwapResultsModal";
import TeacherFixDuplicateChildModal from "../components/TeacherFixDuplicateChildModal";
import TeacherFixDuplicateResultsModal from "../components/TeacherFixDuplicateResultsModal";
import TeacherMoveChildrenModal from "../components/TeacherMoveChildrenModal";
import UpdateTeacherRolesModal from "../components/UpdateTeacherRolesModal";
import TeacherRemoveColleagueAccessModal from "../components/TeacherRemoveColleagueAccessModal";
import RemoveTeacherFromSchoolModal from "../components/RemoveTeacherFromSchoolModal";
import TeacherInviteTeacherModal from "../components/TeacherInviteTeacherModal";
import TeacherSendAccountSetupModal from "../components/TeacherSendAccountSetupModal";
import TeacherSendPasswordResetModal from "../components/TeacherSendPasswordResetModal";
import TeacherUpdateUserEmailModal from "../components/TeacherUpdateUserEmailModal";
import TeacherRenameClassModal from "../components/TeacherRenameClassModal";
import TeacherAssignAlpacaLeadModal from "../components/TeacherAssignAlpacaLeadModal";
import TeacherAssignScreenerModal from "../components/TeacherAssignScreenerModal";
import TeacherExtendTrialModal from "../components/TeacherExtendTrialModal";
import TeacherRestoreChildResultsModal from "../components/TeacherRestoreChildResultsModal";
import TeacherWhatsAppInviteModal from "../components/TeacherWhatsAppInviteModal";
import TeacherProvideLoginBypassModal from "../components/TeacherProvideLoginBypassModal";
import TeacherActivateTeacherAccountModal from "../components/TeacherActivateTeacherAccountModal";
import TeacherMergeClassesModal from "../components/TeacherMergeClassesModal";
import TeacherRemoveTeacherAssignmentModal from "../components/TeacherRemoveTeacherAssignmentModal";
import TeacherEscalateTechnicalIssueModal from "../components/TeacherEscalateTechnicalIssueModal";
import TeacherMakeResultsVisibleModal from "../components/TeacherMakeResultsVisibleModal";
import TeacherResolveLoginIssueModal from "../components/TeacherResolveLoginIssueModal";
import TeacherRenameUserModal from "../components/TeacherRenameUserModal";
import TeacherOfferToAddTeacherModal from "../components/TeacherOfferToAddTeacherModal";
import TeacherOfferMeetingModal from "../components/TeacherOfferMeetingModal";
import TeacherEscalateFeatureRequestModal from "../components/TeacherEscalateFeatureRequestModal";
import TeacherRequestEarlyPlatformAccessModal from "../components/TeacherRequestEarlyPlatformAccessModal";
import TeacherRequestInvoiceModal from "../components/TeacherRequestInvoiceModal";
import TeacherTrialAccessStatusModal from "../components/TeacherTrialAccessStatusModal";
import TeacherFixDuplicateChildResultsModal from "../components/TeacherFixDuplicateChildResultsModal";
import TeacherAladdinExportModal from "../components/TeacherAladdinExportModal";
import TeacherScreeningGuidanceResourcesModal from "../components/TeacherScreeningGuidanceResourcesModal";
import {
  FaChartBar,
  FaUserCheck,
  FaRedo,
  FaSchool,
  FaChalkboardTeacher,
  FaCog,
  FaUsers,
  FaFileExport,
  FaClock,
  FaShieldAlt,
  FaCreditCard,
  FaPlane,
  FaArrowLeft,
  FaUserPlus,
  FaUserMinus,
  FaTrash,
  FaExchangeAlt,
  FaCompressAlt,
  FaClipboardList,
  FaUserCog,
  FaPeopleCarry,
  FaEnvelope,
  FaKey,
  FaMobileAlt,
  FaUserTie,
  FaEdit,
  FaClipboardCheck,
  FaHistory,
  FaHourglassHalf,
  FaQuestionCircle
} from "react-icons/fa";
import { jwtDecode } from "jwt-decode"; 
import { isTeacher, getUserRole } from "../utils/auth";
import {
  SENSAI_EMBED_MODE,
  SENSAI_EMBED_SOURCE,
  SENSAI_EMBEDDED_WORKFLOW_ALLOWLIST,
  postSensaiWorkflowMessage,
  resolveAllowedParentOrigin
} from "../utils/sensaiEmbedWorkflow";

const TEACHER_WORKFLOWS = {
  resetTask: "reset-task",
  addChild: "add-child",
  removeChild: "remove-child",
  createClass: "create-class",
  removeClass: "remove-class",
  requestAccess: "request-access",
  requestAccessOtherTeacher: "request-access-other-teacher",
  swapStudentsResults: "swap-students-results",
  fixDuplicateChild: "fix-duplicate-child",
  fixDuplicateResults: "fix-duplicate-results",
  moveTransferChildren: "move-transfer-children",
  updateTeacherRoles: "update-teacher-roles",
  removeColleagueAccess: "remove-colleague-access",
  removeTeacherFromSchool: "remove-teacher-from-school",
  inviteTeacherToPlatform: "invite-teacher-to-platform",
  sendAccountSetupLink: "send-account-setup-link",
  sendPasswordResetLink: "send-password-reset-link",
  updateUserEmail: "update-user-email",
  renameClass: "rename-class",
  assignAlpacaLead: "assign-alpaca-lead",
  assignScreener: "assign-screener",
  extendTrial: "extend-trial",
  restoreChildResults: "restore-child-results",
  sendWhatsappGroupInvite: "send-whatsapp-group-invite",
  provideLoginBypass: "provide-login-bypass",
  activateTeacherAccount: "activate-teacher-account",
  mergeClasses: "merge-classes",
  removeTeacherAssignment: "remove-teacher-assignment",
  escalateTechnicalIssue: "escalate-technical-issue",
  makeResultsVisible: "make-results-visible",
  resolveLoginIssue: "resolve-login-issue",
  renameUser: "rename-user",
  offerToAddTeacher: "offer-to-add-teacher",
  offerMeeting: "offer-meeting",
  escalateFeatureRequest: "escalate-feature-request",
  requestEarlyPlatformAccess: "request-early-platform-access",
  requestInvoice: "request-invoice",
  trialAccessStatus: "trial-access-status",
  fixDuplicateChildResults: "fix-duplicate-child-results",
  exportAssessmentData: "export-assessment-data",
  screeningGuidanceResources: "screening-guidance-resources"
};

const DEFAULT_TD_URL = "http://localhost:3002";

const normaliseEnvironmentUrl = (url) =>
  String(url || "")
    .trim()
    .replace(/^['"]|['"]$/g, "")
    .replace(/\/+$/g, "");

export const getTeacherDashboardUrl = (path, explicitUrl = "") => {
  const normalisedExplicitUrl = normaliseEnvironmentUrl(explicitUrl);

  if (normalisedExplicitUrl) {
    return normalisedExplicitUrl;
  }

  const tdBaseUrl = normaliseEnvironmentUrl(process.env.REACT_APP_TD_URL) || DEFAULT_TD_URL;
  const normalisedPath = String(path || "").startsWith("/") ? path : `/${path || ""}`;

  return `${tdBaseUrl}${normalisedPath}`;
};

const TD_CLASS_ADMIN_DASHBOARD_PATH = "/classadmindashboard";
const TD_QR_DASHBOARD_PATH = "/qrdashboard";
const TD_RESULTS_DASHBOARD_PATH = "/resultsdashboard";
const TD_SENCO_RESULTS_DETAIL_PATH = "/sencoresults/detail";
const SENSITIVE_WORKFLOW_QUERY_KEYS = ["token", "handoff"];

const normaliseRoleLabel = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ");

export const isSetOrSencoResultsContext = (context = {}) => {
  const roleValues = [
    context.role,
    context.userRole,
    context.roleName,
    context.currentRoleName,
    context.teacherRole,
    context.teacherRoleName,
    context.resultRole,
    context.resultsRole,
    ...(Array.isArray(context.roles) ? context.roles : []),
    ...(Array.isArray(context.roleNames) ? context.roleNames : []),
    ...(Array.isArray(context.teacherRoles) ? context.teacherRoles : [])
  ];

  return roleValues.some((roleValue) => {
    const roleLabel = normaliseRoleLabel(roleValue);
    const roleTokens = roleLabel.split(" ").filter(Boolean);

    return (
      roleTokens.includes("set") ||
      roleTokens.includes("senco") ||
      roleLabel.includes("special education teacher") ||
      roleLabel.includes("special educational teacher") ||
      roleLabel.includes("special educational needs")
    );
  });
};

export const getSwapResultsReturnPath = (context = {}) =>
  isSetOrSencoResultsContext(context)
    ? TD_SENCO_RESULTS_DETAIL_PATH
    : TD_RESULTS_DASHBOARD_PATH;

const addWorkflowPrefillParams = (params, prefill = {}) => {
  Object.entries(prefill).forEach(([key, value]) => {
    if (value === undefined || value === null || String(value).trim() === "") {
      return;
    }

    params.set(
      `prefill.${key}`,
      Array.isArray(value) ? value.filter(Boolean).join(", ") : String(value)
    );
  });
};

const WORKFLOW_CONTEXT_QUERY_KEYS = [
  "source",
  "embed",
  "launchId",
  "parentOrigin",
  "context",
  "classId",
  "className",
  "classLevel",
  "studentId",
  "studentName",
  "studentClassName",
  "teacherId",
  "secondStudentName",
  "secondStudentClassName",
  "teacherName",
  "secondTeacherName",
  "roleName",
  "roleNames",
  "currentRoleName",
  "removeRoleNames",
  "email",
  "currentEmail",
  "newEmail",
  "mobileNumber",
  "whatsappGroupName",
  "deliveryMethod",
  "schoolName",
  "classNames",
  "newClassName",
  "fromClassName",
  "toClassName",
  "screenerName",
  "trialEndsOn",
  "assessmentId",
  "assessmentName",
  "groupId",
  "resultId",
  "taskName",
  "reason",
  "note",
  "issueType",
  "deviceType",
  "browser",
  "operatingSystem",
  "numberAffected",
  "description",
  "assignmentTarget",
  "firstName",
  "lastName",
  "newTeacherName",
  "teacherNames",
  "teacherEmails",
  "teachers",
  "meetingTopic",
  "requestedDate",
  "requestedTime",
  "featureArea",
  "featureIdea",
  "benefit",
  "followUpPreference",
  "accessType",
  "screeningWindow",
  "requestedOpenDate",
  "reopenPeriod",
  "invoiceRequestType",
  "requestType",
  "recipientEmail",
  "poNumber",
  "trialIssue",
  "trialStatus",
  "resultIssueType",
  "resultReviewRoute",
  "reviewRoute",
  "exportAction",
  "guidanceQuery",
  "resourceTitle",
  "resourceName",
  "resourceType",
  "resourceAction",
  "support.eal",
  "support.speechAndLanguage",
  "support.asd",
  "support.gdd",
  "prefill.className",
  "prefill.classId",
  "prefill.classLevel",
  "prefill.studentId",
  "prefill.studentName",
  "prefill.studentClassName",
  "prefill.teacherId",
  "prefill.secondStudentName",
  "prefill.secondStudentClassName",
  "prefill.teacherName",
  "prefill.secondTeacherName",
  "prefill.roleName",
  "prefill.roleNames",
  "prefill.currentRoleName",
  "prefill.removeRoleNames",
  "prefill.email",
  "prefill.currentEmail",
  "prefill.newEmail",
  "prefill.mobileNumber",
  "prefill.whatsappGroupName",
  "prefill.deliveryMethod",
  "prefill.schoolName",
  "prefill.classNames",
  "prefill.newClassName",
  "prefill.fromClassName",
  "prefill.toClassName",
  "prefill.screenerName",
  "prefill.trialEndsOn",
  "prefill.assessmentId",
  "prefill.assessmentName",
  "prefill.groupId",
  "prefill.resultId",
  "prefill.studentNames",
  "prefill.taskName",
  "prefill.reason",
  "prefill.note",
  "prefill.issueType",
  "prefill.deviceType",
  "prefill.browser",
  "prefill.operatingSystem",
  "prefill.numberAffected",
  "prefill.description",
  "prefill.assignmentTarget",
  "prefill.firstName",
  "prefill.lastName",
  "prefill.newTeacherName",
  "prefill.teacherNames",
  "prefill.teacherEmails",
  "prefill.teachers",
  "prefill.meetingTopic",
  "prefill.requestedDate",
  "prefill.requestedTime",
  "prefill.featureArea",
  "prefill.featureIdea",
  "prefill.benefit",
  "prefill.followUpPreference",
  "prefill.accessType",
  "prefill.screeningWindow",
  "prefill.requestedOpenDate",
  "prefill.reopenPeriod",
  "prefill.invoiceRequestType",
  "prefill.requestType",
  "prefill.recipientEmail",
  "prefill.poNumber",
  "prefill.trialIssue",
  "prefill.trialStatus",
  "prefill.resultIssueType",
  "prefill.resultReviewRoute",
  "prefill.reviewRoute",
  "prefill.exportAction",
  "prefill.guidanceQuery",
  "prefill.resourceTitle",
  "prefill.resourceName",
  "prefill.resourceType",
  "prefill.resourceAction",
  "prefill.support.eal",
  "prefill.support.speechAndLanguage",
  "prefill.support.asd",
  "prefill.support.gdd",
  "prefill[className]",
  "prefill[classLevel]",
  "prefill[studentName]",
  "prefill[studentClassName]",
  "prefill[secondStudentName]",
  "prefill[secondStudentClassName]",
  "prefill[teacherName]",
  "prefill[secondTeacherName]",
  "prefill[roleName]",
  "prefill[roleNames]",
  "prefill[currentRoleName]",
  "prefill[removeRoleNames]",
  "prefill[email]",
  "prefill[currentEmail]",
  "prefill[newEmail]",
  "prefill[mobileNumber]",
  "prefill[whatsappGroupName]",
  "prefill[deliveryMethod]",
  "prefill[schoolName]",
  "prefill[classNames]",
  "prefill[newClassName]",
  "prefill[fromClassName]",
  "prefill[toClassName]",
  "prefill[screenerName]",
  "prefill[trialEndsOn]",
  "prefill[assessmentName]",
  "prefill[studentNames]",
  "prefill[taskName]",
  "prefill[reason]",
  "prefill[note]",
  "prefill[issueType]",
  "prefill[deviceType]",
  "prefill[browser]",
  "prefill[operatingSystem]",
  "prefill[numberAffected]",
  "prefill[description]",
  "prefill[assignmentTarget]",
  "prefill[firstName]",
  "prefill[lastName]",
  "prefill[newTeacherName]",
  "prefill[teacherNames]",
  "prefill[teacherEmails]",
  "prefill[teachers]",
  "prefill[meetingTopic]",
  "prefill[requestedDate]",
  "prefill[requestedTime]",
  "prefill[featureArea]",
  "prefill[featureIdea]",
  "prefill[benefit]",
  "prefill[followUpPreference]",
  "prefill[accessType]",
  "prefill[screeningWindow]",
  "prefill[requestedOpenDate]",
  "prefill[reopenPeriod]",
  "prefill[invoiceRequestType]",
  "prefill[requestType]",
  "prefill[recipientEmail]",
  "prefill[poNumber]",
  "prefill[trialIssue]",
  "prefill[trialStatus]",
  "prefill[resultIssueType]",
  "prefill[resultReviewRoute]",
  "prefill[reviewRoute]",
  "prefill[exportAction]",
  "prefill[guidanceQuery]",
  "prefill[resourceTitle]",
  "prefill[resourceName]",
  "prefill[resourceType]",
  "prefill[resourceAction]",
  "prefill[support][eal]",
  "prefill[support][speechAndLanguage]",
  "prefill[support][asd]",
  "prefill[support][gdd]"
];

const decodeBase64Url = (encodedValue) => {
  const base64 = encodedValue
    .replace(/-/g, "+")
    .replace(/_/g, "/")
    .padEnd(Math.ceil(encodedValue.length / 4) * 4, "=");
  const binary = window.atob(base64);
  const escaped = Array.from(binary, (character) =>
    `%${character.charCodeAt(0).toString(16).padStart(2, "0")}`
  ).join("");

  return decodeURIComponent(escaped);
};

const parseWorkflowContext = (encodedContext) => {
  if (!encodedContext) {
    return {};
  }

  const parseAttempts = [
    () => JSON.parse(encodedContext),
    () => JSON.parse(decodeBase64Url(encodedContext))
  ];

  for (const parseAttempt of parseAttempts) {
    try {
      const parsedContext = parseAttempt();
      return parsedContext && typeof parsedContext === "object" ? parsedContext : {};
    } catch (error) {
      // Try the next supported context format.
    }
  }

  return {};
};

const firstPresentValue = (...values) =>
  values.find((value) => value !== undefined && value !== null && String(value).trim() !== "") || "";

const firstPresentBoolean = (...values) => {
  const value = values.find((item) => item !== undefined && item !== null && String(item).trim() !== "");

  if (value === true || value === false) {
    return value;
  }

  return ["true", "1", "yes"].includes(String(value || "").trim().toLowerCase());
};

const getWorkflowLaunchContext = (searchParams) => {
  const encodedContext = searchParams.get("context");
  const parsedContext = parseWorkflowContext(encodedContext);
  const prefill = parsedContext?.prefill || {};
  const support = prefill?.support || {};

  return {
    workflow: firstPresentValue(searchParams.get("workflow"), parsedContext?.workflow),
    source: firstPresentValue(searchParams.get("source"), parsedContext?.source),
    embed: firstPresentValue(searchParams.get("embed"), parsedContext?.embed),
    launchId: firstPresentValue(searchParams.get("launchId"), parsedContext?.launchId),
    parentOrigin: firstPresentValue(searchParams.get("parentOrigin"), parsedContext?.parentOrigin),
    schoolId: firstPresentValue(searchParams.get("schoolId"), searchParams.get("schoolid"), parsedContext?.schoolId),
    prefill: {
      classId: firstPresentValue(
        searchParams.get("prefill.classId"),
        searchParams.get("prefill[classId]"),
        searchParams.get("classId"),
        prefill.classId,
        prefill.class_id
      ),
      className: firstPresentValue(
        searchParams.get("prefill.className"),
        searchParams.get("prefill[className]"),
        searchParams.get("className"),
        prefill.className,
        prefill.class_name
      ),
      classLevel: firstPresentValue(
        searchParams.get("prefill.classLevel"),
        searchParams.get("prefill[classLevel]"),
        searchParams.get("classLevel"),
        prefill.classLevel,
        prefill.class_level
      ),
      studentId: firstPresentValue(
        searchParams.get("prefill.studentId"),
        searchParams.get("prefill[studentId]"),
        searchParams.get("studentId"),
        prefill.studentId,
        prefill.student_id
      ),
      studentName: firstPresentValue(
        searchParams.get("prefill.studentName"),
        searchParams.get("prefill[studentName]"),
        searchParams.get("studentName"),
        prefill.studentName,
        prefill.student_name
      ),
      studentClassName: firstPresentValue(
        searchParams.get("prefill.studentClassName"),
        searchParams.get("prefill[studentClassName]"),
        searchParams.get("studentClassName"),
        prefill.studentClassName,
        prefill.student_class_name
      ),
      teacherId: firstPresentValue(
        searchParams.get("prefill.teacherId"),
        searchParams.get("prefill[teacherId]"),
        searchParams.get("teacherId"),
        prefill.teacherId,
        prefill.teacher_id
      ),
      secondStudentName: firstPresentValue(
        searchParams.get("prefill.secondStudentName"),
        searchParams.get("prefill[secondStudentName]"),
        searchParams.get("secondStudentName"),
        prefill.secondStudentName,
        prefill.second_student_name,
        prefill.intendedStudentName,
        prefill.intended_student_name
      ),
      secondStudentClassName: firstPresentValue(
        searchParams.get("prefill.secondStudentClassName"),
        searchParams.get("prefill[secondStudentClassName]"),
        searchParams.get("secondStudentClassName"),
        prefill.secondStudentClassName,
        prefill.second_student_class_name
      ),
      teacherName: firstPresentValue(
        searchParams.get("prefill.teacherName"),
        searchParams.get("prefill[teacherName]"),
        searchParams.get("teacherName"),
        prefill.teacherName,
        prefill.teacher_name
      ),
      secondTeacherName: firstPresentValue(
        searchParams.get("prefill.secondTeacherName"),
        searchParams.get("prefill[secondTeacherName]"),
        searchParams.get("secondTeacherName"),
        prefill.secondTeacherName,
        prefill.second_teacher_name,
        prefill.classOwnerTeacherName,
        prefill.class_owner_teacher_name
      ),
      roleName: firstPresentValue(
        searchParams.get("prefill.roleName"),
        searchParams.get("prefill[roleName]"),
        searchParams.get("roleName"),
        prefill.roleName,
        prefill.role_name
      ),
      roleNames: firstPresentValue(
        searchParams.get("prefill.roleNames"),
        searchParams.get("prefill[roleNames]"),
        searchParams.get("roleNames"),
        prefill.roleNames,
        prefill.role_names
      ),
      currentRoleName: firstPresentValue(
        searchParams.get("prefill.currentRoleName"),
        searchParams.get("prefill[currentRoleName]"),
        searchParams.get("currentRoleName"),
        prefill.currentRoleName,
        prefill.current_role_name
      ),
      removeRoleNames: firstPresentValue(
        searchParams.get("prefill.removeRoleNames"),
        searchParams.get("prefill[removeRoleNames]"),
        searchParams.get("removeRoleNames"),
        prefill.removeRoleNames,
        prefill.remove_role_names
      ),
      email: firstPresentValue(
        searchParams.get("prefill.email"),
        searchParams.get("prefill[email]"),
        searchParams.get("email"),
        prefill.email
      ),
      currentEmail: firstPresentValue(
        searchParams.get("prefill.currentEmail"),
        searchParams.get("prefill[currentEmail]"),
        searchParams.get("currentEmail"),
        prefill.currentEmail,
        prefill.current_email
      ),
      newEmail: firstPresentValue(
        searchParams.get("prefill.newEmail"),
        searchParams.get("prefill[newEmail]"),
        searchParams.get("newEmail"),
        prefill.newEmail,
        prefill.new_email
      ),
      mobileNumber: firstPresentValue(
        searchParams.get("prefill.mobileNumber"),
        searchParams.get("prefill[mobileNumber]"),
        searchParams.get("mobileNumber"),
        prefill.mobileNumber,
        prefill.mobile_number
      ),
      whatsappGroupName: firstPresentValue(
        searchParams.get("prefill.whatsappGroupName"),
        searchParams.get("prefill[whatsappGroupName]"),
        searchParams.get("whatsappGroupName"),
        prefill.whatsappGroupName,
        prefill.whatsapp_group_name
      ),
      deliveryMethod: firstPresentValue(
        searchParams.get("prefill.deliveryMethod"),
        searchParams.get("prefill[deliveryMethod]"),
        searchParams.get("deliveryMethod"),
        prefill.deliveryMethod,
        prefill.delivery_method
      ),
      schoolName: firstPresentValue(
        searchParams.get("prefill.schoolName"),
        searchParams.get("prefill[schoolName]"),
        searchParams.get("schoolName"),
        prefill.schoolName,
        prefill.school_name
      ),
      classNames: firstPresentValue(
        searchParams.get("prefill.classNames"),
        searchParams.get("prefill[classNames]"),
        searchParams.get("classNames"),
        prefill.classNames,
        prefill.class_names
      ),
      newClassName: firstPresentValue(
        searchParams.get("prefill.newClassName"),
        searchParams.get("prefill[newClassName]"),
        searchParams.get("newClassName"),
        prefill.newClassName,
        prefill.new_class_name
      ),
      fromClassName: firstPresentValue(
        searchParams.get("prefill.fromClassName"),
        searchParams.get("prefill[fromClassName]"),
        searchParams.get("fromClassName"),
        prefill.fromClassName,
        prefill.from_class_name,
        prefill.className,
        prefill.class_name
      ),
      toClassName: firstPresentValue(
        searchParams.get("prefill.toClassName"),
        searchParams.get("prefill[toClassName]"),
        searchParams.get("toClassName"),
        prefill.toClassName,
        prefill.to_class_name,
        prefill.newClassName,
        prefill.new_class_name
      ),
      screenerName: firstPresentValue(
        searchParams.get("prefill.screenerName"),
        searchParams.get("prefill[screenerName]"),
        searchParams.get("screenerName"),
        prefill.screenerName,
        prefill.screener_name
      ),
      trialEndsOn: firstPresentValue(
        searchParams.get("prefill.trialEndsOn"),
        searchParams.get("prefill[trialEndsOn]"),
        searchParams.get("trialEndsOn"),
        prefill.trialEndsOn,
        prefill.trial_ends_on
      ),
      assessmentName: firstPresentValue(
        searchParams.get("prefill.assessmentName"),
        searchParams.get("prefill[assessmentName]"),
        searchParams.get("assessmentName"),
        prefill.assessmentName,
        prefill.assessment_name
      ),
      assessmentId: firstPresentValue(
        searchParams.get("prefill.assessmentId"),
        searchParams.get("prefill[assessmentId]"),
        searchParams.get("assessmentId"),
        prefill.assessmentId,
        prefill.assessment_id
      ),
      groupId: firstPresentValue(
        searchParams.get("prefill.groupId"),
        searchParams.get("prefill[groupId]"),
        searchParams.get("groupId"),
        prefill.groupId,
        prefill.group_id
      ),
      resultId: firstPresentValue(
        searchParams.get("prefill.resultId"),
        searchParams.get("prefill[resultId]"),
        searchParams.get("resultId"),
        prefill.resultId,
        prefill.result_id
      ),
      studentNames: firstPresentValue(
        searchParams.get("prefill.studentNames"),
        searchParams.get("prefill[studentNames]"),
        searchParams.get("studentNames"),
        prefill.studentNames,
        prefill.student_names,
        prefill.children,
        prefill.childNames,
        prefill.child_names
      ),
      taskName: firstPresentValue(
        searchParams.get("prefill.taskName"),
        searchParams.get("prefill[taskName]"),
        searchParams.get("taskName"),
        prefill.taskName,
        prefill.task_name
      ),
      reason: firstPresentValue(
        searchParams.get("prefill.reason"),
        searchParams.get("prefill[reason]"),
        searchParams.get("reason"),
        prefill.reason
      ),
      note: firstPresentValue(
        searchParams.get("prefill.note"),
        searchParams.get("prefill[note]"),
        searchParams.get("note"),
        prefill.note
      ),
      issueType: firstPresentValue(
        searchParams.get("prefill.issueType"),
        searchParams.get("prefill[issueType]"),
        searchParams.get("issueType"),
        prefill.issueType,
        prefill.issue_type
      ),
      deviceType: firstPresentValue(
        searchParams.get("prefill.deviceType"),
        searchParams.get("prefill[deviceType]"),
        searchParams.get("deviceType"),
        prefill.deviceType,
        prefill.device_type
      ),
      browser: firstPresentValue(
        searchParams.get("prefill.browser"),
        searchParams.get("prefill[browser]"),
        searchParams.get("browser"),
        prefill.browser
      ),
      operatingSystem: firstPresentValue(
        searchParams.get("prefill.operatingSystem"),
        searchParams.get("prefill[operatingSystem]"),
        searchParams.get("operatingSystem"),
        prefill.operatingSystem,
        prefill.operating_system
      ),
      numberAffected: firstPresentValue(
        searchParams.get("prefill.numberAffected"),
        searchParams.get("prefill[numberAffected]"),
        searchParams.get("numberAffected"),
        prefill.numberAffected,
        prefill.number_affected
      ),
      description: firstPresentValue(
        searchParams.get("prefill.description"),
        searchParams.get("prefill[description]"),
        searchParams.get("description"),
        prefill.description
      ),
      assignmentTarget: firstPresentValue(
        searchParams.get("prefill.assignmentTarget"),
        searchParams.get("prefill[assignmentTarget]"),
        searchParams.get("assignmentTarget"),
        prefill.assignmentTarget,
        prefill.assignment_target
      ),
      firstName: firstPresentValue(
        searchParams.get("prefill.firstName"),
        searchParams.get("prefill[firstName]"),
        searchParams.get("firstName"),
        prefill.firstName,
        prefill.first_name
      ),
      lastName: firstPresentValue(
        searchParams.get("prefill.lastName"),
        searchParams.get("prefill[lastName]"),
        searchParams.get("lastName"),
        prefill.lastName,
        prefill.last_name
      ),
      newTeacherName: firstPresentValue(
        searchParams.get("prefill.newTeacherName"),
        searchParams.get("prefill[newTeacherName]"),
        searchParams.get("newTeacherName"),
        prefill.newTeacherName,
        prefill.new_teacher_name
      ),
      teacherNames: firstPresentValue(
        searchParams.get("prefill.teacherNames"),
        searchParams.get("prefill[teacherNames]"),
        searchParams.get("teacherNames"),
        prefill.teacherNames,
        prefill.teacher_names,
        prefill.teachers
      ),
      teacherEmails: firstPresentValue(
        searchParams.get("prefill.teacherEmails"),
        searchParams.get("prefill[teacherEmails]"),
        searchParams.get("teacherEmails"),
        prefill.teacherEmails,
        prefill.teacher_emails
      ),
      teachers: firstPresentValue(
        searchParams.get("prefill.teachers"),
        searchParams.get("prefill[teachers]"),
        searchParams.get("teachers"),
        prefill.teachers,
        prefill.teacherNames,
        prefill.teacher_names
      ),
      meetingTopic: firstPresentValue(
        searchParams.get("prefill.meetingTopic"),
        searchParams.get("prefill[meetingTopic]"),
        searchParams.get("meetingTopic"),
        prefill.meetingTopic,
        prefill.meeting_topic
      ),
      requestedDate: firstPresentValue(
        searchParams.get("prefill.requestedDate"),
        searchParams.get("prefill[requestedDate]"),
        searchParams.get("requestedDate"),
        prefill.requestedDate,
        prefill.requested_date
      ),
      requestedTime: firstPresentValue(
        searchParams.get("prefill.requestedTime"),
        searchParams.get("prefill[requestedTime]"),
        searchParams.get("requestedTime"),
        prefill.requestedTime,
        prefill.requested_time
      ),
      featureArea: firstPresentValue(
        searchParams.get("prefill.featureArea"),
        searchParams.get("prefill[featureArea]"),
        searchParams.get("featureArea"),
        prefill.featureArea,
        prefill.feature_area
      ),
      featureIdea: firstPresentValue(
        searchParams.get("prefill.featureIdea"),
        searchParams.get("prefill[featureIdea]"),
        searchParams.get("featureIdea"),
        prefill.featureIdea,
        prefill.feature_idea
      ),
      benefit: firstPresentValue(
        searchParams.get("prefill.benefit"),
        searchParams.get("prefill[benefit]"),
        searchParams.get("benefit"),
        prefill.benefit
      ),
      followUpPreference: firstPresentValue(
        searchParams.get("prefill.followUpPreference"),
        searchParams.get("prefill[followUpPreference]"),
        searchParams.get("followUpPreference"),
        prefill.followUpPreference,
        prefill.follow_up_preference
      ),
      accessType: firstPresentValue(
        searchParams.get("prefill.accessType"),
        searchParams.get("prefill[accessType]"),
        searchParams.get("accessType"),
        prefill.accessType,
        prefill.access_type
      ),
      screeningWindow: firstPresentValue(
        searchParams.get("prefill.screeningWindow"),
        searchParams.get("prefill[screeningWindow]"),
        searchParams.get("screeningWindow"),
        prefill.screeningWindow,
        prefill.screening_window
      ),
      requestedOpenDate: firstPresentValue(
        searchParams.get("prefill.requestedOpenDate"),
        searchParams.get("prefill[requestedOpenDate]"),
        searchParams.get("requestedOpenDate"),
        prefill.requestedOpenDate,
        prefill.requested_open_date
      ),
      reopenPeriod: firstPresentValue(
        searchParams.get("prefill.reopenPeriod"),
        searchParams.get("prefill[reopenPeriod]"),
        searchParams.get("reopenPeriod"),
        prefill.reopenPeriod,
        prefill.reopen_period
      ),
      invoiceRequestType: firstPresentValue(
        searchParams.get("prefill.invoiceRequestType"),
        searchParams.get("prefill[invoiceRequestType]"),
        searchParams.get("prefill.requestType"),
        searchParams.get("prefill[requestType]"),
        searchParams.get("invoiceRequestType"),
        searchParams.get("requestType"),
        prefill.invoiceRequestType,
        prefill.invoice_request_type,
        prefill.requestType,
        prefill.request_type
      ),
      recipientEmail: firstPresentValue(
        searchParams.get("prefill.recipientEmail"),
        searchParams.get("prefill[recipientEmail]"),
        searchParams.get("recipientEmail"),
        prefill.recipientEmail,
        prefill.recipient_email
      ),
      poNumber: firstPresentValue(
        searchParams.get("prefill.poNumber"),
        searchParams.get("prefill[poNumber]"),
        searchParams.get("poNumber"),
        prefill.poNumber,
        prefill.po_number
      ),
      trialIssue: firstPresentValue(
        searchParams.get("prefill.trialIssue"),
        searchParams.get("prefill[trialIssue]"),
        searchParams.get("prefill.trialStatus"),
        searchParams.get("prefill[trialStatus]"),
        searchParams.get("trialIssue"),
        searchParams.get("trialStatus"),
        prefill.trialIssue,
        prefill.trial_issue,
        prefill.trialStatus
      ),
      resultIssueType: firstPresentValue(
        searchParams.get("prefill.resultIssueType"),
        searchParams.get("prefill[resultIssueType]"),
        searchParams.get("resultIssueType"),
        prefill.resultIssueType,
        prefill.result_issue_type
      ),
      resultReviewRoute: firstPresentValue(
        searchParams.get("prefill.resultReviewRoute"),
        searchParams.get("prefill[resultReviewRoute]"),
        searchParams.get("prefill.reviewRoute"),
        searchParams.get("prefill[reviewRoute]"),
        searchParams.get("resultReviewRoute"),
        searchParams.get("reviewRoute"),
        prefill.resultReviewRoute,
        prefill.result_review_route,
        prefill.reviewRoute,
        prefill.review_route
      ),
      exportAction: firstPresentValue(
        searchParams.get("prefill.exportAction"),
        searchParams.get("prefill[exportAction]"),
        searchParams.get("exportAction"),
        prefill.exportAction,
        prefill.export_action
      ),
      guidanceQuery: firstPresentValue(
        searchParams.get("prefill.guidanceQuery"),
        searchParams.get("prefill[guidanceQuery]"),
        searchParams.get("guidanceQuery"),
        prefill.guidanceQuery,
        prefill.guidance_query
      ),
      resourceTitle: firstPresentValue(
        searchParams.get("prefill.resourceTitle"),
        searchParams.get("prefill[resourceTitle]"),
        searchParams.get("prefill.resourceName"),
        searchParams.get("prefill[resourceName]"),
        searchParams.get("resourceTitle"),
        searchParams.get("resourceName"),
        prefill.resourceTitle,
        prefill.resource_title,
        prefill.resourceName,
        prefill.resource_name
      ),
      resourceType: firstPresentValue(
        searchParams.get("prefill.resourceType"),
        searchParams.get("prefill[resourceType]"),
        searchParams.get("resourceType"),
        prefill.resourceType,
        prefill.resource_type
      ),
      resourceAction: firstPresentValue(
        searchParams.get("prefill.resourceAction"),
        searchParams.get("prefill[resourceAction]"),
        searchParams.get("resourceAction"),
        prefill.resourceAction,
        prefill.resource_action
      ),
      support: {
        eal: firstPresentBoolean(
          searchParams.get("prefill.support.eal"),
          searchParams.get("prefill[support][eal]"),
          searchParams.get("support.eal"),
          support.eal
        ),
        speechAndLanguage: firstPresentBoolean(
          searchParams.get("prefill.support.speechAndLanguage"),
          searchParams.get("prefill[support][speechAndLanguage]"),
          searchParams.get("support.speechAndLanguage"),
          support.speechAndLanguage,
          support.speech_and_language
        ),
        asd: firstPresentBoolean(
          searchParams.get("prefill.support.asd"),
          searchParams.get("prefill[support][asd]"),
          searchParams.get("support.asd"),
          support.asd
        ),
        gdd: firstPresentBoolean(
          searchParams.get("prefill.support.gdd"),
          searchParams.get("prefill[support][gdd]"),
          searchParams.get("support.gdd"),
          support.gdd
        )
      }
    }
  };
};

const clearWorkflowLaunchParams = (searchParams) => {
  WORKFLOW_CONTEXT_QUERY_KEYS.forEach((key) => {
    searchParams.delete(key);
  });
  SENSITIVE_WORKFLOW_QUERY_KEYS.forEach((key) => {
    searchParams.delete(key);
  });
};

function MasterDashboard() {
  const [schoolid, setSchoolid] = useState(null);
  const [schoolRollNumber, setSchoolRollNumber] = useState("");
  const [schoolCountryId, setSchoolCountryId] = useState(null);
  const [schoolCountryGrades, setSchoolCountryGrades] = useState(null);
  const [teacherid, setTeacherid] = useState(null);
  const [name, setName] = useState("");
  const [teacherEmail, setTeacherEmail] = useState("");
  const [loading, setLoading] = useState(true);
  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );
  const [sharedClassId, setSharedClassId] = useState(null);
  const [teacherSearchQuery, setTeacherSearchQuery] = useState("");
  const [appliedTeacherSearchQuery, setAppliedTeacherSearchQuery] = useState("");
  const [showTeacherResetModal, setShowTeacherResetModal] = useState(false);
  const [showTeacherAddChildModal, setShowTeacherAddChildModal] = useState(false);
  const [showTeacherRemoveChildModal, setShowTeacherRemoveChildModal] = useState(false);
  const [showTeacherCreateClassModal, setShowTeacherCreateClassModal] = useState(false);
  const [showTeacherRemoveClassModal, setShowTeacherRemoveClassModal] = useState(false);
  const [showTeacherRequestAccessModal, setShowTeacherRequestAccessModal] = useState(false);
  const [showTeacherSwapResultsModal, setShowTeacherSwapResultsModal] = useState(false);
  const [showTeacherFixDuplicateChildModal, setShowTeacherFixDuplicateChildModal] = useState(false);
  const [showTeacherFixDuplicateResultsModal, setShowTeacherFixDuplicateResultsModal] = useState(false);
  const [showTeacherMoveChildrenModal, setShowTeacherMoveChildrenModal] = useState(false);
  const [showUpdateTeacherRolesModal, setShowUpdateTeacherRolesModal] = useState(false);
  const [showTeacherRemoveColleagueAccessModal, setShowTeacherRemoveColleagueAccessModal] = useState(false);
  const [showRemoveTeacherFromSchoolModal, setShowRemoveTeacherFromSchoolModal] = useState(false);
  const [showTeacherInviteTeacherModal, setShowTeacherInviteTeacherModal] = useState(false);
  const [showTeacherSendAccountSetupModal, setShowTeacherSendAccountSetupModal] = useState(false);
  const [showTeacherSendPasswordResetModal, setShowTeacherSendPasswordResetModal] = useState(false);
  const [showTeacherUpdateUserEmailModal, setShowTeacherUpdateUserEmailModal] = useState(false);
  const [showTeacherRenameClassModal, setShowTeacherRenameClassModal] = useState(false);
  const [showTeacherAssignAlpacaLeadModal, setShowTeacherAssignAlpacaLeadModal] = useState(false);
  const [showTeacherAssignScreenerModal, setShowTeacherAssignScreenerModal] = useState(false);
  const [showTeacherExtendTrialModal, setShowTeacherExtendTrialModal] = useState(false);
  const [showTeacherRestoreChildResultsModal, setShowTeacherRestoreChildResultsModal] = useState(false);
  const [showTeacherWhatsAppInviteModal, setShowTeacherWhatsAppInviteModal] = useState(false);
  const [preferredAddChildClass, setPreferredAddChildClass] = useState(null);

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  // ✅ Check if current user is a teacher
  const teacherMode = isTeacher();
  const workflowLaunchContext = useMemo(
    () => getWorkflowLaunchContext(searchParams),
    [searchParams]
  );
  const activeTeacherWorkflow = workflowLaunchContext.workflow;
  const isSensaiEmbedMode = workflowLaunchContext.embed === SENSAI_EMBED_MODE;
  const sensaiEmbedTargetOrigin = useMemo(
    () =>
      resolveAllowedParentOrigin(
        workflowLaunchContext.parentOrigin,
        typeof document !== "undefined" ? document.referrer : ""
      ),
    [workflowLaunchContext.parentOrigin]
  );
  const isAllowedSensaiWorkflow = SENSAI_EMBEDDED_WORKFLOW_ALLOWLIST.includes(activeTeacherWorkflow);
  const isValidSensaiEmbedLaunch = Boolean(
    isSensaiEmbedMode &&
      workflowLaunchContext.source === SENSAI_EMBED_SOURCE &&
      activeTeacherWorkflow &&
      workflowLaunchContext.launchId &&
      sensaiEmbedTargetOrigin
  );
  const sensaiEmbedErrorMessage = (() => {
    if (!isSensaiEmbedMode) {
      return "";
    }

    if (workflowLaunchContext.source !== SENSAI_EMBED_SOURCE) {
      return "This embedded workflow launch is missing the required TD source.";
    }

    if (!activeTeacherWorkflow) {
      return "This embedded workflow launch is missing a workflow.";
    }

    if (!workflowLaunchContext.launchId) {
      return "This embedded workflow launch is missing a launch ID.";
    }

    if (!sensaiEmbedTargetOrigin) {
      return "This embedded workflow launch is not from an approved Teacher Dashboard origin.";
    }

    if (!isAllowedSensaiWorkflow) {
      return "This workflow is not available in SENSAI yet.";
    }

    return "";
  })();
  const embedLifecycleMessageKeyRef = useRef("");
  const postEmbedWorkflowMessage = useCallback(
    (type, options = {}) =>
      postSensaiWorkflowMessage({
        parentWindow: window.parent,
        targetOrigin: sensaiEmbedTargetOrigin,
        type,
        workflow: activeTeacherWorkflow,
        launchId: workflowLaunchContext.launchId,
        status: options.status,
        reference: options.reference,
        message: options.message
      }),
    [activeTeacherWorkflow, sensaiEmbedTargetOrigin, workflowLaunchContext.launchId]
  );
  const showTeacherProvideLoginBypassModal = activeTeacherWorkflow === TEACHER_WORKFLOWS.provideLoginBypass;
  const showTeacherActivateTeacherAccountModal = activeTeacherWorkflow === TEACHER_WORKFLOWS.activateTeacherAccount;
  const showTeacherMergeClassesModal = activeTeacherWorkflow === TEACHER_WORKFLOWS.mergeClasses;
  const showTeacherRemoveTeacherAssignmentModal = activeTeacherWorkflow === TEACHER_WORKFLOWS.removeTeacherAssignment;
  const showTeacherEscalateTechnicalIssueModal = activeTeacherWorkflow === TEACHER_WORKFLOWS.escalateTechnicalIssue;
  const showTeacherMakeResultsVisibleModal = activeTeacherWorkflow === TEACHER_WORKFLOWS.makeResultsVisible;
  const showTeacherResolveLoginIssueModal = activeTeacherWorkflow === TEACHER_WORKFLOWS.resolveLoginIssue;
  const showTeacherRenameUserModal = activeTeacherWorkflow === TEACHER_WORKFLOWS.renameUser;
  const showTeacherOfferToAddTeacherModal = activeTeacherWorkflow === TEACHER_WORKFLOWS.offerToAddTeacher;
  const showTeacherOfferMeetingModal = activeTeacherWorkflow === TEACHER_WORKFLOWS.offerMeeting;
  const showTeacherEscalateFeatureRequestModal = activeTeacherWorkflow === TEACHER_WORKFLOWS.escalateFeatureRequest;
  const showTeacherRequestEarlyPlatformAccessModal =
    activeTeacherWorkflow === TEACHER_WORKFLOWS.requestEarlyPlatformAccess;
  const showTeacherRequestInvoiceModal = activeTeacherWorkflow === TEACHER_WORKFLOWS.requestInvoice;
  const showTeacherTrialAccessStatusModal = activeTeacherWorkflow === TEACHER_WORKFLOWS.trialAccessStatus;
  const showTeacherFixDuplicateChildResultsModal =
    activeTeacherWorkflow === TEACHER_WORKFLOWS.fixDuplicateChildResults;
  const showTeacherAladdinExportModal = activeTeacherWorkflow === TEACHER_WORKFLOWS.exportAssessmentData;
  const showTeacherScreeningGuidanceResourcesModal =
    activeTeacherWorkflow === TEACHER_WORKFLOWS.screeningGuidanceResources;

  const clearTeacherWorkflowReference = (workflow) => {
    const nextParams = new URLSearchParams(searchParams);
    const currentWorkflow = getWorkflowLaunchContext(nextParams).workflow;

    if (currentWorkflow === workflow) {
      nextParams.delete("workflow");
      clearWorkflowLaunchParams(nextParams);
      setSearchParams(nextParams, { replace: true });
    }
  };

  const preserveCurrentScrollPosition = () => {
    const scrollX = window.scrollX;
    const scrollY = window.scrollY;
    const restoreScrollPosition = () => {
      if (
        typeof window.scrollTo !== "function" ||
        (window.navigator?.userAgent?.includes("jsdom") && !window.scrollTo._isMockFunction)
      ) {
        return;
      }

      try {
        window.scrollTo(scrollX, scrollY);
      } catch (scrollError) {
        // Some test/browser shells expose scrollTo but do not implement it.
      }
    };

    window.requestAnimationFrame(() => {
      restoreScrollPosition();
      window.requestAnimationFrame(restoreScrollPosition);
    });
  };

  const openTeacherWorkflow = (workflow, options = {}) => {
    const nextParams = new URLSearchParams(searchParams);
    clearWorkflowLaunchParams(nextParams);
    nextParams.set("workflow", workflow);
    if (options.preserveEmbedLaunch && isSensaiEmbedMode) {
      nextParams.set("source", workflowLaunchContext.source);
      nextParams.set("embed", workflowLaunchContext.embed);
      nextParams.set("launchId", workflowLaunchContext.launchId);
      if (workflowLaunchContext.parentOrigin) {
        nextParams.set("parentOrigin", workflowLaunchContext.parentOrigin);
      }
      if (workflowLaunchContext.schoolId) {
        nextParams.set("schoolId", workflowLaunchContext.schoolId);
      }
    }
    addWorkflowPrefillParams(nextParams, options.prefill);
    setSearchParams(nextParams);
    preserveCurrentScrollPosition();

    if (workflow === TEACHER_WORKFLOWS.addChild) {
      setPreferredAddChildClass(options.preferredClass || null);
    } else {
      setPreferredAddChildClass(null);
    }

    setShowTeacherResetModal(workflow === TEACHER_WORKFLOWS.resetTask);
    setShowTeacherAddChildModal(workflow === TEACHER_WORKFLOWS.addChild);
    setShowTeacherRemoveChildModal(workflow === TEACHER_WORKFLOWS.removeChild);
    setShowTeacherCreateClassModal(workflow === TEACHER_WORKFLOWS.createClass);
    setShowTeacherRemoveClassModal(workflow === TEACHER_WORKFLOWS.removeClass);
    setShowTeacherRequestAccessModal(
      workflow === TEACHER_WORKFLOWS.requestAccess ||
      workflow === TEACHER_WORKFLOWS.requestAccessOtherTeacher
    );
    setShowTeacherSwapResultsModal(workflow === TEACHER_WORKFLOWS.swapStudentsResults);
    setShowTeacherFixDuplicateChildModal(workflow === TEACHER_WORKFLOWS.fixDuplicateChild);
    setShowTeacherFixDuplicateResultsModal(workflow === TEACHER_WORKFLOWS.fixDuplicateResults);
    setShowTeacherMoveChildrenModal(workflow === TEACHER_WORKFLOWS.moveTransferChildren);
    setShowUpdateTeacherRolesModal(workflow === TEACHER_WORKFLOWS.updateTeacherRoles);
    setShowTeacherRemoveColleagueAccessModal(workflow === TEACHER_WORKFLOWS.removeColleagueAccess);
    setShowRemoveTeacherFromSchoolModal(workflow === TEACHER_WORKFLOWS.removeTeacherFromSchool);
    setShowTeacherInviteTeacherModal(workflow === TEACHER_WORKFLOWS.inviteTeacherToPlatform);
    setShowTeacherSendAccountSetupModal(workflow === TEACHER_WORKFLOWS.sendAccountSetupLink);
    setShowTeacherSendPasswordResetModal(workflow === TEACHER_WORKFLOWS.sendPasswordResetLink);
    setShowTeacherUpdateUserEmailModal(workflow === TEACHER_WORKFLOWS.updateUserEmail);
    setShowTeacherRenameClassModal(workflow === TEACHER_WORKFLOWS.renameClass);
    setShowTeacherAssignAlpacaLeadModal(workflow === TEACHER_WORKFLOWS.assignAlpacaLead);
    setShowTeacherAssignScreenerModal(workflow === TEACHER_WORKFLOWS.assignScreener);
    setShowTeacherExtendTrialModal(workflow === TEACHER_WORKFLOWS.extendTrial);
    setShowTeacherRestoreChildResultsModal(workflow === TEACHER_WORKFLOWS.restoreChildResults);
    setShowTeacherWhatsAppInviteModal(workflow === TEACHER_WORKFLOWS.sendWhatsappGroupInvite);
  };

  const closeTeacherWorkflow = (workflow) => {
    if (workflow === TEACHER_WORKFLOWS.resetTask) {
      setShowTeacherResetModal(false);
    }

    if (workflow === TEACHER_WORKFLOWS.addChild) {
      setShowTeacherAddChildModal(false);
      setPreferredAddChildClass(null);
    }

    if (workflow === TEACHER_WORKFLOWS.removeChild) {
      setShowTeacherRemoveChildModal(false);
    }

    if (workflow === TEACHER_WORKFLOWS.createClass) {
      setShowTeacherCreateClassModal(false);
    }

    if (workflow === TEACHER_WORKFLOWS.removeClass) {
      setShowTeacherRemoveClassModal(false);
    }

    if (
      workflow === TEACHER_WORKFLOWS.requestAccess ||
      workflow === TEACHER_WORKFLOWS.requestAccessOtherTeacher
    ) {
      setShowTeacherRequestAccessModal(false);
    }

    if (workflow === TEACHER_WORKFLOWS.swapStudentsResults) {
      setShowTeacherSwapResultsModal(false);
    }

    if (workflow === TEACHER_WORKFLOWS.fixDuplicateChild) {
      setShowTeacherFixDuplicateChildModal(false);
    }

    if (workflow === TEACHER_WORKFLOWS.fixDuplicateResults) {
      setShowTeacherFixDuplicateResultsModal(false);
    }

    if (workflow === TEACHER_WORKFLOWS.moveTransferChildren) {
      setShowTeacherMoveChildrenModal(false);
    }

    if (workflow === TEACHER_WORKFLOWS.updateTeacherRoles) {
      setShowUpdateTeacherRolesModal(false);
    }

    if (workflow === TEACHER_WORKFLOWS.removeColleagueAccess) {
      setShowTeacherRemoveColleagueAccessModal(false);
    }

    if (workflow === TEACHER_WORKFLOWS.removeTeacherFromSchool) {
      setShowRemoveTeacherFromSchoolModal(false);
    }

    if (workflow === TEACHER_WORKFLOWS.inviteTeacherToPlatform) {
      setShowTeacherInviteTeacherModal(false);
    }

    if (workflow === TEACHER_WORKFLOWS.sendAccountSetupLink) {
      setShowTeacherSendAccountSetupModal(false);
    }

    if (workflow === TEACHER_WORKFLOWS.sendPasswordResetLink) {
      setShowTeacherSendPasswordResetModal(false);
    }

    if (workflow === TEACHER_WORKFLOWS.updateUserEmail) {
      setShowTeacherUpdateUserEmailModal(false);
    }

    if (workflow === TEACHER_WORKFLOWS.renameClass) {
      setShowTeacherRenameClassModal(false);
    }

    if (workflow === TEACHER_WORKFLOWS.assignAlpacaLead) {
      setShowTeacherAssignAlpacaLeadModal(false);
    }

    if (workflow === TEACHER_WORKFLOWS.assignScreener) {
      setShowTeacherAssignScreenerModal(false);
    }

    if (workflow === TEACHER_WORKFLOWS.extendTrial) {
      setShowTeacherExtendTrialModal(false);
    }

    if (workflow === TEACHER_WORKFLOWS.restoreChildResults) {
      setShowTeacherRestoreChildResultsModal(false);
    }

    if (workflow === TEACHER_WORKFLOWS.sendWhatsappGroupInvite) {
      setShowTeacherWhatsAppInviteModal(false);
    }

    clearTeacherWorkflowReference(workflow);
  };

  const closeEmbeddedTeacherWorkflow = (workflow, message = "Workflow cancelled.") => {
    if (isSensaiEmbedMode) {
      postEmbedWorkflowMessage("workflow.cancelled", {
        status: "cancelled",
        message
      });
    }

    closeTeacherWorkflow(workflow);
  };

  const completeEmbeddedTeacherWorkflow = (workflow, details = {}) => {
    if (isSensaiEmbedMode) {
      postEmbedWorkflowMessage("workflow.completed", {
        status: "success",
        reference: details.reference,
        message: details.message || "Workflow complete."
      });
    }

    closeTeacherWorkflow(workflow);
  };

  const closeTeacherWorkflowForMode = (workflow, message = "Workflow cancelled.") => {
    if (isSensaiEmbedMode) {
      closeEmbeddedTeacherWorkflow(workflow, message);
      return;
    }

    closeTeacherWorkflow(workflow);
  };

  const completeTeacherWorkflowForMode = (workflow, details = {}) => {
    if (isSensaiEmbedMode) {
      completeEmbeddedTeacherWorkflow(workflow, details);
      return;
    }

    closeTeacherWorkflow(workflow);
  };

  const createEmbeddedCompleteHandler = (workflow, message = "Workflow complete.") => (details = {}) =>
    completeTeacherWorkflowForMode(workflow, {
      ...details,
      message: details.message || message
    });

  // ✅ DEBUG: Token and role detection
  useEffect(() => {
    console.log('🚀 MasterDashboard mounted - checking authentication...');
    const token = localStorage.getItem('token');
    console.log('🔍 Token in localStorage:', token ? 'EXISTS' : 'MISSING');

    if (token) {
      try {
        const decoded = jwtDecode(token);
        console.log('👤 Roles:', decoded.roles);
        console.log('⏰ Expires:', new Date(decoded.exp * 1000));
        console.log('⏰ Current Time:', new Date());
        console.log('✅ Token Valid:', new Date(decoded.exp * 1000) > new Date());
      } catch (error) {
        console.error('❌ Token decode error:', error);
      }
    }

    const role = getUserRole();
    console.log('🎭 Detected Role:', role);
    console.log('👨‍🏫 Teacher Mode:', teacherMode);
  }, [teacherMode]);

  // ✅ Teacher-only featured cards
  // Featured admin cards (full for alpaca-staff)
  const teacherPortalActions = [
    {
      name: "REQUEST ACCESS",
      description: "Ask for access to a class you need.",
      icon: FaUserCheck,
      color: "#7c3aed",
      softColor: "#f5f3ff",
      borderColor: "#ddd6fe",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.requestAccess)
    },
    {
      name: "REQUEST ACCESS FOR TEACHER",
      description: "Ask for another teacher to access one class.",
      icon: FaUsers,
      color: "#7c3aed",
      softColor: "#f5f3ff",
      borderColor: "#ddd6fe",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.requestAccessOtherTeacher)
    },
    {
      name: "INVITE TEACHER",
      description: "Invite a teacher and choose class access.",
      icon: FaUserPlus,
      color: "#2563eb",
      softColor: "#eff6ff",
      borderColor: "#bfdbfe",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.inviteTeacherToPlatform)
    },
    {
      name: "SEND ACCOUNT SETUP LINK",
      description: "Resend setup access to an invited teacher.",
      icon: FaEnvelope,
      color: "#2563eb",
      softColor: "#eff6ff",
      borderColor: "#bfdbfe",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.sendAccountSetupLink)
    },
    {
      name: "SEND PASSWORD RESET LINK",
      description: "Send a reset link to a colleague.",
      icon: FaKey,
      color: "#7c3aed",
      softColor: "#f5f3ff",
      borderColor: "#ddd6fe",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.sendPasswordResetLink)
    },
    {
      name: "UPDATE USER EMAIL",
      description: "Request an account email change.",
      icon: FaEnvelope,
      color: "#0f766e",
      softColor: "#f0fdfa",
      borderColor: "#99f6e4",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.updateUserEmail)
    },
    {
      name: "ACTIVATE TEACHER ACCOUNT",
      description: "Send setup access to a teacher who is not active.",
      icon: FaUserCheck,
      color: "#2563eb",
      softColor: "#eff6ff",
      borderColor: "#bfdbfe",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.activateTeacherAccount)
    },
    {
      name: "RESOLVE LOGIN ISSUE",
      description: "Choose the right login fix for a colleague.",
      icon: FaKey,
      color: "#7c3aed",
      softColor: "#f5f3ff",
      borderColor: "#ddd6fe",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.resolveLoginIssue)
    },
    {
      name: "RENAME USER",
      description: "Request a displayed teacher name change.",
      icon: FaEdit,
      color: "#0f766e",
      softColor: "#f0fdfa",
      borderColor: "#99f6e4",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.renameUser)
    },
    {
      name: "OFFER TO ADD TEACHER",
      description: "Invite multiple teachers or handle existing accounts.",
      icon: FaUserPlus,
      color: "#2563eb",
      softColor: "#eff6ff",
      borderColor: "#bfdbfe",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.offerToAddTeacher)
    },
    {
      name: "REQUEST INVOICE",
      description: "Ask for an invoice copy or invoice detail update.",
      icon: FaCreditCard,
      color: "#0f766e",
      softColor: "#f0fdfa",
      borderColor: "#99f6e4",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.requestInvoice)
    },
    {
      name: "CREATE CLASS",
      description: "Create one class for your pupils.",
      icon: FaChalkboardTeacher,
      color: "#16a34a",
      softColor: "#f0fdf4",
      borderColor: "#bbf7d0",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.createClass)
    },
    {
      name: "REMOVE CLASS",
      description: "Remove one class from your class list.",
      icon: FaTrash,
      color: "#dc2626",
      softColor: "#fef2f2",
      borderColor: "#fecaca",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.removeClass)
    },
    {
      name: "RENAME CLASS",
      description: "Change one class name.",
      icon: FaEdit,
      color: "#2563eb",
      softColor: "#eff6ff",
      borderColor: "#bfdbfe",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.renameClass)
    },
    {
      name: "ASSIGN SCREENER",
      description: "Assign a screener to one class.",
      icon: FaClipboardCheck,
      color: "#16a34a",
      softColor: "#f0fdf4",
      borderColor: "#bbf7d0",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.assignScreener)
    },
    {
      name: "ASSIGN ALPACA LEAD",
      description: "Choose the ALPACA Lead for this school.",
      icon: FaUserTie,
      color: "#0f766e",
      softColor: "#f0fdfa",
      borderColor: "#99f6e4",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.assignAlpacaLead)
    },
    {
      name: "EXTEND TRIAL",
      description: "Request more time for the school trial.",
      icon: FaHourglassHalf,
      color: "#f59e0b",
      softColor: "#fff7ed",
      borderColor: "#fed7aa",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.extendTrial)
    },
    {
      name: "MERGE CLASSES",
      description: "Review and combine duplicated class records.",
      icon: FaCompressAlt,
      color: "#0f766e",
      softColor: "#f0fdfa",
      borderColor: "#99f6e4",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.mergeClasses)
    },
    {
      name: "REMOVE TEACHER ASSIGNMENT",
      description: "Remove a teacher from one class and choose ownership.",
      icon: FaUserMinus,
      color: "#dc2626",
      softColor: "#fef2f2",
      borderColor: "#fecaca",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.removeTeacherAssignment)
    },
    {
      name: "REQUEST EARLY PLATFORM ACCESS",
      description: "Ask to open or reopen a screening window.",
      icon: FaHourglassHalf,
      color: "#f59e0b",
      softColor: "#fff7ed",
      borderColor: "#fed7aa",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.requestEarlyPlatformAccess)
    },
    {
      name: "TRIAL ACCESS STATUS",
      description: "Ask ALPACA to review trial access or expired access.",
      icon: FaHourglassHalf,
      color: "#f59e0b",
      softColor: "#fff7ed",
      borderColor: "#fed7aa",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.trialAccessStatus)
    },
    {
      name: "ADD CHILD",
      description: "Add one missing child to an existing class.",
      icon: FaUserPlus,
      color: "#2563eb",
      softColor: "#eff6ff",
      borderColor: "#bfdbfe",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.addChild)
    },
    {
      name: "REMOVE CHILD",
      description: "Remove one child from your class list.",
      icon: FaUserMinus,
      color: "#dc2626",
      softColor: "#fef2f2",
      borderColor: "#fecaca",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.removeChild)
    },
    {
      name: "FIX DUPLICATE CHILD",
      description: "Fix a child who appears twice in one class.",
      icon: FaCompressAlt,
      color: "#0f766e",
      softColor: "#f0fdfa",
      borderColor: "#99f6e4",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.fixDuplicateChild)
    },
    {
      name: "FIX DUPLICATE RESULTS",
      description: "Choose which repeated result should stay visible.",
      icon: FaClipboardList,
      color: "#0f766e",
      softColor: "#f0fdfa",
      borderColor: "#99f6e4",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.fixDuplicateResults)
    },
    {
      name: "FIX CHILD RESULTS",
      description: "Send split, missing, or duplicate child results for review.",
      icon: FaClipboardList,
      color: "#0f766e",
      softColor: "#f0fdfa",
      borderColor: "#99f6e4",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.fixDuplicateChildResults)
    },
    {
      name: "RESTORE CHILD RESULTS",
      description: "Restore deleted task answers for a child.",
      icon: FaHistory,
      color: "#0f766e",
      softColor: "#f0fdfa",
      borderColor: "#99f6e4",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.restoreChildResults)
    },
    {
      name: "SWAP STUDENTS RESULTS",
      description: "Move a result to the child you meant to scan.",
      icon: FaExchangeAlt,
      color: "#2563eb",
      softColor: "#eff6ff",
      borderColor: "#bfdbfe",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.swapStudentsResults)
    },
    {
      name: "MOVE CHILDREN",
      description: "Move children to another class.",
      icon: FaPeopleCarry,
      color: "#2563eb",
      softColor: "#eff6ff",
      borderColor: "#bfdbfe",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.moveTransferChildren)
    },
    {
      name: "UPDATE TEACHER ROLES",
      description: "Update teacher role labels only.",
      icon: FaUserCog,
      color: "#0f766e",
      softColor: "#f0fdfa",
      borderColor: "#99f6e4",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.updateTeacherRoles)
    },
    {
      name: "REMOVE COLLEAGUE ACCESS",
      description: "Remove a colleague from one class.",
      icon: FaUserMinus,
      color: "#dc2626",
      softColor: "#fef2f2",
      borderColor: "#fecaca",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.removeColleagueAccess)
    },
    {
      name: "REMOVE TEACHER FROM SCHOOL",
      description: "Remove one teacher from this school.",
      icon: FaTrash,
      color: "#dc2626",
      softColor: "#fef2f2",
      borderColor: "#fecaca",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.removeTeacherFromSchool)
    },
    {
      name: "GET WHATSAPP INVITE",
      description: "Send yourself a WhatsApp group invite.",
      icon: FaMobileAlt,
      color: "#16a34a",
      softColor: "#f0fdf4",
      borderColor: "#bbf7d0",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.sendWhatsappGroupInvite)
    },
    {
      name: "PROVIDE LOGIN BYPASS",
      description: "Create child login links when QR scanning is blocked.",
      icon: FaKey,
      color: "#16a34a",
      softColor: "#f0fdf4",
      borderColor: "#bbf7d0",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.provideLoginBypass)
    },
    {
      name: "MAKE RESULTS VISIBLE",
      description: "Request access to a class or results you cannot see.",
      icon: FaChartBar,
      color: "#7c3aed",
      softColor: "#f5f3ff",
      borderColor: "#ddd6fe",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.makeResultsVisible)
    },
    {
      name: "ALADDIN EXPORT",
      description: "Check export readiness for a class and screener.",
      icon: FaFileExport,
      color: "#2563eb",
      softColor: "#eff6ff",
      borderColor: "#bfdbfe",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.exportAssessmentData)
    },
    {
      name: "CONTACT SUPPORT",
      description: "Report a technical problem that needs support review.",
      icon: FaCog,
      color: "#dc2626",
      softColor: "#fef2f2",
      borderColor: "#fecaca",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.escalateTechnicalIssue)
    },
    {
      name: "OFFER MEETING",
      description: "Request a meeting or try a short guide first.",
      icon: FaClock,
      color: "#2563eb",
      softColor: "#eff6ff",
      borderColor: "#bfdbfe",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.offerMeeting)
    },
    {
      name: "SEARCH HELP AND GUIDANCE",
      description: "Find guidance, videos, PDFs, and recommended resources.",
      icon: FaQuestionCircle,
      color: "#7c3aed",
      softColor: "#f5f3ff",
      borderColor: "#ddd6fe",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.screeningGuidanceResources)
    },
    {
      name: "SUGGEST AN IMPROVEMENT",
      description: "Capture a product idea or related feedback.",
      icon: FaClipboardList,
      color: "#0f766e",
      softColor: "#f0fdfa",
      borderColor: "#99f6e4",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.escalateFeatureRequest)
    },
    {
      name: "RESET TASK",
      description: "Choose a pupil and select a task for retake.",
      icon: FaRedo,
      color: "#f59e0b",
      softColor: "#fff7ed",
      borderColor: "#fed7aa",
      onClick: () => openTeacherWorkflow(TEACHER_WORKFLOWS.resetTask)
    }
  ];

  const filteredTeacherPortalActions = teacherPortalActions.filter((action) => {
    const query = appliedTeacherSearchQuery.trim().toLowerCase();
    if (!query) return true;
    return [action.name, action.description].some((value) =>
      value.toLowerCase().includes(query)
    );
  });

  const allFeaturedCards = [
    {
      name: "School Admin",
      path: "/schooladmin",
      icon: FaSchool,
      description: "Manage schools and institutional data",
      color: "#ec4899"
    },
    {
      name: "Class Admin",
      path: "/classadmin",
      icon: FaChalkboardTeacher,
      description: "Administer classes and assignments",
      color: "#10b981"
    },
    {
      name: "User Admin",
      path: "/userexistence",
      icon: FaUsers,
      description: "Verify user accounts and status",
      color: "#06b6d4"
    },
    {
      name: "Screener Admin",
      path: "/screenermanagement",
      icon: FaShieldAlt,
      description: "Configure screening assessments",
      color: "#ef4444"
    }
  ];

  // Admin sections configuration (alpaca-staff only)
  const adminSections = [
    {
      title: "Analytics & Reports",
      items: [
        {
          name: "Reports",
          path: "/reports",
          icon: FaChartBar,
          description: "View detailed analytics and generate reports",
          color: "#3b82f6"
        },
        {
          name: "Aladdin Export",
          path: "/aladdinexport",
          icon: FaFileExport,
          description: "Export data to Aladdin system",
          color: "#06b6d4"
        }
      ]
    },
    {
      title: "System Administration",
      items: [
        {
          name: "Resetting Tasks",
          path: "/resettasks",
          icon: FaRedo,
          description: "Reset and manage system tasks",
          color: "#f59e0b"
        }
      ]
    },
    {
      title: "Program Management",
      items: [
        {
          name: "Trial Management",
          path: "/trialmanagement",
          icon: FaClock,
          description: "Manage trial accounts and periods",
          color: "#ec4899"
        },
        {
          name: "Purchase Management",
          path: "/purchasemanagement",
          icon: FaCreditCard,
          description: "Handle purchases and subscriptions",
          color: "#f97316"
        },
        {
          name: "Pilot Management",
          path: "/pilotmanagement",
          icon: FaPlane,
          description: "Manage pilot programs and testing",
          color: "#0ea5e9"
        }
      ]
    },
    {
      title: "Advanced Settings",
      items: [
        {
          name: "Internal Admin",
          path: "/internaladmin",
          icon: FaCog,
          description: "Advanced system configuration",
          color: "#6b7280"
        }
      ]
    }
  ];

  // ✅ Select cards based on role
  useEffect(() => {
    window.HubSpotConversations?.widget?.refresh();
  }, []);

  useEffect(() => {
    if (!teacherMode) {
      return;
    }

    setShowTeacherResetModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.resetTask);
    setShowTeacherAddChildModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.addChild);
    setShowTeacherRemoveChildModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.removeChild);
    setShowTeacherCreateClassModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.createClass);
    setShowTeacherRemoveClassModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.removeClass);
    setShowTeacherRequestAccessModal(
      activeTeacherWorkflow === TEACHER_WORKFLOWS.requestAccess ||
      activeTeacherWorkflow === TEACHER_WORKFLOWS.requestAccessOtherTeacher
    );
    setShowTeacherSwapResultsModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.swapStudentsResults);
    setShowTeacherFixDuplicateChildModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.fixDuplicateChild);
    setShowTeacherFixDuplicateResultsModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.fixDuplicateResults);
    setShowTeacherMoveChildrenModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.moveTransferChildren);
    setShowUpdateTeacherRolesModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.updateTeacherRoles);
    setShowTeacherRemoveColleagueAccessModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.removeColleagueAccess);
    setShowRemoveTeacherFromSchoolModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.removeTeacherFromSchool);
    setShowTeacherInviteTeacherModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.inviteTeacherToPlatform);
    setShowTeacherSendAccountSetupModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.sendAccountSetupLink);
    setShowTeacherSendPasswordResetModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.sendPasswordResetLink);
    setShowTeacherUpdateUserEmailModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.updateUserEmail);
    setShowTeacherRenameClassModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.renameClass);
    setShowTeacherAssignAlpacaLeadModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.assignAlpacaLead);
    setShowTeacherAssignScreenerModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.assignScreener);
    setShowTeacherExtendTrialModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.extendTrial);
    setShowTeacherRestoreChildResultsModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.restoreChildResults);
    setShowTeacherWhatsAppInviteModal(activeTeacherWorkflow === TEACHER_WORKFLOWS.sendWhatsappGroupInvite);
  }, [activeTeacherWorkflow, teacherMode]);

  useEffect(() => {
    if (!isSensaiEmbedMode || loading) {
      return;
    }

    const messageType = sensaiEmbedErrorMessage ? "workflow.error" : "workflow.ready";
    const messageKey = `${messageType}:${activeTeacherWorkflow}:${workflowLaunchContext.launchId}:${sensaiEmbedErrorMessage}`;

    if (embedLifecycleMessageKeyRef.current === messageKey) {
      return;
    }

    embedLifecycleMessageKeyRef.current = messageKey;

    if (sensaiEmbedErrorMessage) {
      postEmbedWorkflowMessage("workflow.error", {
        status: "error",
        message: sensaiEmbedErrorMessage
      });
      return;
    }

    if (isValidSensaiEmbedLaunch && isAllowedSensaiWorkflow) {
      postEmbedWorkflowMessage("workflow.ready", {
        status: "ready"
      });
    }
  }, [
    activeTeacherWorkflow,
    isAllowedSensaiWorkflow,
    isSensaiEmbedMode,
    isValidSensaiEmbedLaunch,
    loading,
    postEmbedWorkflowMessage,
    sensaiEmbedErrorMessage,
    workflowLaunchContext.launchId
  ]);

  useEffect(() => {
    if (!teacherMode) {
      setShowUpdateTeacherRolesModal(false);
      setShowTeacherRemoveColleagueAccessModal(false);
      setShowRemoveTeacherFromSchoolModal(false);
      setShowTeacherInviteTeacherModal(false);
      setShowTeacherSendAccountSetupModal(false);
      setShowTeacherSendPasswordResetModal(false);
      setShowTeacherUpdateUserEmailModal(false);
      setShowTeacherRenameClassModal(false);
      setShowTeacherAssignAlpacaLeadModal(false);
      setShowTeacherAssignScreenerModal(false);
      setShowTeacherExtendTrialModal(false);
      setShowTeacherRestoreChildResultsModal(false);
      setShowTeacherWhatsAppInviteModal(false);
    }
  }, [teacherMode]);

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);
    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);

  // ✅ UPDATED: Added error handling and debugging to whoami
  useEffect(() => {
    const savedSharedClassId = localStorage.getItem("sharedClassId");
    const loggedInAlready = localStorage.getItem('loggedInAlready');
    const newUserSignup = localStorage.getItem('newUserSignup');

    if (savedSharedClassId) {
      setSharedClassId(savedSharedClassId);
      console.log("Shared Class ID from local storage:", savedSharedClassId);
    }

    console.log('📞 Calling whoami API...');
    whoami()
      .then(async (response) => {
        console.log('👤 User roles from API:', response.data.roles);

        const schoolId = response.data.stakeholder.schoolid;
        const fallbackCountryId =
          response.data.stakeholder.countryId ||
          response.data.stakeholder.countryid ||
          response.data.school?.countryId ||
          response.data.school?.countryid ||
          null;

        let resolvedCountryId = fallbackCountryId;

        try {
          const countryLookup = schoolId ? await getCountryId(schoolId) : null;
          resolvedCountryId = countryLookup?.countryId || countryLookup?.countryid || fallbackCountryId;
        } catch (countryError) {
          console.error("Error fetching school country:", countryError);
        }

        let resolvedCountryGrades = null;

        try {
          resolvedCountryGrades = resolvedCountryId ? await getCountryGrades(resolvedCountryId) : null;
        } catch (countryGradesError) {
          console.error("Error fetching school country grades:", countryGradesError);
        }

        setSchoolid(schoolId);
        setSchoolRollNumber(
          response.data.stakeholder.rollnumber ||
          response.data.stakeholder.rollNumber ||
          response.data.school?.rollnumber ||
          response.data.school?.rollNumber ||
          ""
        );
        setSchoolCountryId(resolvedCountryId);
        setSchoolCountryGrades(resolvedCountryGrades);
        setTeacherid(response.data.stakeholder.id);
        setName(response.data.stakeholder.name);
        setTeacherEmail(response.data.stakeholder.email || "");

        if (loggedInAlready === 'true') {
          console.log('Profile already updated or new user just signed up, skipping login check.');
          return;
        }

        getLastLogin(response.data.stakeholder.id)
          .then((lastLoginData) => {
            const lastLogin = lastLoginData ? new Date(lastLoginData.lastloggedin) : null;
            const thresholdDate = new Date('2024-09-01T00:00:00Z');

            postLastLogin(response.data.stakeholder.id)
              .then(() => {
                console.log("Last login logged successfully");
                localStorage.setItem('loggedInAlready', 'true');

                if (newUserSignup === 'true') {
                  console.log('Profile already updated or new user just signed up, skipping login check.');
                  return;
                }

                if (!lastLogin || lastLogin < thresholdDate) {
                  console.log("Redirecting to profile due to first login or outdated last login.");
                  navigate(`/profile`, { state: { teacherid: response.data.stakeholder.id, profilePageRedirect: true } });
                }
              })
              .catch((error) => {
                console.error("Error logging last login:", error);
              });
          })
          .catch((error) => {
            console.error("Error fetching last login:", error);
          });
      })
      .catch((error) => {
        console.error('❌ WHOAMI Failed:', error);
        console.error('❌ Error Response:', error.response);
        console.error('❌ Status Code:', error.response?.status);
        console.error('❌ Status Text:', error.response?.statusText);
        console.error('❌ Error Data:', error.response?.data);

        // Check if it's an authentication error
        if (error.response?.status === 401 || error.response?.status === 403) {
          console.error('🚫 Authentication/Authorization failed - redirecting to login');
          // The error might be causing a redirect somewhere
        }
      });
  }, [navigate]);

  useEffect(() => {
    if (schoolid) {
      if (teacherMode) {
        setLoading(false);
        return;
      }

      getClasses()
        .then(() => {
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching classes:", error);
          setLoading(false);
        });
    }
  }, [schoolid, teacherMode]);

  useEffect(() => {
    if (sharedClassId && teacherid) {
      shareClass(sharedClassId, teacherid, true)
        .then(() => {
          localStorage.removeItem("sharedClassId");
        })
        .catch((error) => {
          console.error("Error sharing class:", error);
        });
    }
  }, [sharedClassId, teacherid]);

  useEffect(() => {
    const fromCreateClass = localStorage.getItem("fromCreateClass");
    if (fromCreateClass === "true" && sharedClassId && teacherid) {
      updateClassOwnerId(sharedClassId, teacherid)
        .then((updatedClass) => {
          console.log("Class owner ID updated successfully:", updatedClass);
          localStorage.removeItem("fromCreateClass");
        })
        .catch((error) => {
          console.error("Error updating class owner ID:", error);
        });
    }
  }, [sharedClassId, teacherid]);

  const AdminCard = ({ item }) => (
    <Link to={item.path} className="admin-card-link">
      <Card className="admin-card">
        <Card.Body className="admin-card-body">
          <div className="admin-card-icon" style={{ backgroundColor: `${item.color}15`, color: item.color }}>
            <item.icon size={24} />
          </div>
          <div className="admin-card-content">
            <h5 className="admin-card-title">{item.name}</h5>
            <p className="admin-card-description">{item.description}</p>
          </div>
          <div className="admin-card-arrow" style={{ color: item.color }}>
            →
          </div>
        </Card.Body>
      </Card>
    </Link>
  );

  const handleTeacherSearchChange = (event) => {
    const nextQuery = event.target.value;
    setTeacherSearchQuery(nextQuery);
    setAppliedTeacherSearchQuery(nextQuery);
  };

  const handleReturnToTD = () => {
    if (isSensaiEmbedMode) {
      completeEmbeddedTeacherWorkflow(activeTeacherWorkflow, {
        message: "Workflow complete."
      });
      return;
    }

    const tdAdminUrl = getTeacherDashboardUrl("/admindashboard", process.env.REACT_APP_TD_ADMIN_DASHBOARD);
    console.log('ðŸ”™ Returning to TD Admin Dashboard:', tdAdminUrl);

    localStorage.removeItem('source_app');
    localStorage.removeItem('teacher_school_id');

    window.location.href = tdAdminUrl;
  };

  const handleCreatedClassAddChildren = (createdClass) => {
    setShowTeacherCreateClassModal(false);
    openTeacherWorkflow(TEACHER_WORKFLOWS.addChild, {
      preferredClass: createdClass,
      preserveEmbedLaunch: isSensaiEmbedMode
    });
  };

  const handleRequestAccessOppositeFlowBridge = () => {
    const nextWorkflow =
      activeTeacherWorkflow === TEACHER_WORKFLOWS.requestAccessOtherTeacher
        ? TEACHER_WORKFLOWS.requestAccess
        : TEACHER_WORKFLOWS.requestAccessOtherTeacher;
    openTeacherWorkflow(nextWorkflow, {
      preserveEmbedLaunch: isSensaiEmbedMode
    });
  };

  const handleMergeClassesReturnToTeacherDashboard = () => {
    if (isSensaiEmbedMode) {
      completeEmbeddedTeacherWorkflow(activeTeacherWorkflow, {
        message: "Workflow complete."
      });
      return;
    }

    localStorage.removeItem("source_app");
    localStorage.removeItem("teacher_school_id");
    window.location.href = getTeacherDashboardUrl(TD_CLASS_ADMIN_DASHBOARD_PATH);
  };

  const handleAssignScreenerBridge = ({ className } = {}) => {
    setShowTeacherAddChildModal(false);
    setShowTeacherMoveChildrenModal(false);
    setPreferredAddChildClass(null);

    openTeacherWorkflow(TEACHER_WORKFLOWS.assignScreener, {
      prefill: { className },
      preserveEmbedLaunch: isSensaiEmbedMode
    });
  };

  const handleMoveChildrenAddMissingChild = ({ studentName, classItem } = {}) => {
    setShowTeacherMoveChildrenModal(false);
    openTeacherWorkflow(TEACHER_WORKFLOWS.addChild, {
      preferredClass: classItem,
      preserveEmbedLaunch: isSensaiEmbedMode,
      prefill: {
        studentName,
        className: classItem?.name
      }
    });
  };

  const openTeacherDashboardBridge = (path) => {
    if (isSensaiEmbedMode) {
      completeEmbeddedTeacherWorkflow(activeTeacherWorkflow, {
        message: "Workflow complete."
      });
      return;
    }

    localStorage.removeItem("source_app");
    localStorage.removeItem("teacher_school_id");
    window.location.href = getTeacherDashboardUrl(path);
  };

  const getDecodedTokenRoles = () => {
    try {
      const token = localStorage.getItem("token");
      return token ? jwtDecode(token)?.roles || [] : [];
    } catch (decodeError) {
      return [];
    }
  };

  const handleViewStudentResultsBridge = () => {
    openTeacherDashboardBridge(getSwapResultsReturnPath({ roles: getDecodedTokenRoles() }));
  };

  const handleSwapResultsReturnBridge = () => {
    openTeacherDashboardBridge(getSwapResultsReturnPath({ roles: getDecodedTokenRoles() }));
  };

  const handleViewQrCodesBridge = () => {
    openTeacherDashboardBridge(TD_QR_DASHBOARD_PATH);
  };

  const handleGoToClassListBridge = () => {
    openTeacherDashboardBridge(TD_CLASS_ADMIN_DASHBOARD_PATH);
  };

  const openTeacherWorkflowBridge = (workflow, prefill = {}) => {
    if (
      isSensaiEmbedMode &&
      !SENSAI_EMBEDDED_WORKFLOW_ALLOWLIST.includes(workflow)
    ) {
      completeEmbeddedTeacherWorkflow(activeTeacherWorkflow, {
        message: "This workflow continues in Teacher Dashboard."
      });
      return;
    }

    openTeacherWorkflow(workflow, {
      prefill,
      preserveEmbedLaunch: isSensaiEmbedMode
    });
  };

  const TeacherActionCard = ({ action }) => {
    const Icon = action.icon;
    const actionStyle = {
      "--teacher-action-color": action.color,
      "--teacher-action-soft": action.softColor,
      "--teacher-action-border": action.borderColor
    };

    return (
      <button
        aria-label={action.name}
        className="teacher-portal-action"
        style={actionStyle}
        type="button"
        onClick={action.onClick}
      >
        <span className="teacher-portal-action-icon">
          <Icon />
        </span>
        <span className="teacher-portal-action-copy">
          <span className="teacher-portal-action-title">{action.name}</span>
          <span className="teacher-portal-action-description">{action.description}</span>
        </span>
      </button>
    );
  };

  return (
    <div>
      <Container fluid className={`dashboard-container${isSensaiEmbedMode ? " sensai-embed-container" : ""}`}>
        {!isSensaiEmbedMode && (
          <HeadingBanner
            name={`Welcome ${name}!`}
            isLoggedIn={true}
            cloud={true}
            teacherid={teacherid}
          />
        )}
        <Row className="dashboard-row">
          {!isSensaiEmbedMode && <LeftPanel />}
          <Col
            as="main"
            sm={isSensaiEmbedMode ? 12 : { span: 10, offset: 2 }}
            className={`main-content${isSensaiEmbedMode ? " sensai-embed-main" : ""}`}
          >
            {loading ? (
              <div className="loading-container">
                <div className="loading-spinner"></div>
                <p className="loading-text">Loading dashboard...</p>
              </div>
            ) : (
              <div className="dashboard-content">
                {teacherMode ? (
                  <div className={`teacher-portal-section${isSensaiEmbedMode ? " sensai-embed-shell" : ""}`}>
                    {!isSensaiEmbedMode && (
                      <>
                        <div className="return-to-td-banner">
                          <button onClick={handleReturnToTD} className="return-to-td-button" type="button">
                            <FaArrowLeft style={{ marginRight: '8px' }} />
                            Return to Teacher Dashboard
                          </button>
                        </div>

                        <div className="dashboard-header">
                          <h2 className="dashboard-title">Teacher Admin Portal</h2>
                        </div>

                        <div className="teacher-portal-search-row">
                          <Form.Control
                            type="search"
                            value={teacherSearchQuery}
                            onChange={handleTeacherSearchChange}
                            aria-label="Search teacher admin actions"
                            placeholder="Search teacher admin actions"
                          />
                        </div>

                        {filteredTeacherPortalActions.length > 0 ? (
                          <div className="teacher-portal-actions">
                            {filteredTeacherPortalActions.map((action) => (
                              <TeacherActionCard key={action.name} action={action} />
                            ))}
                          </div>
                        ) : (
                          <div className="teacher-portal-empty-state">
                            <strong>No actions match that search.</strong>
                          </div>
                        )}
                      </>
                    )}

                    {isSensaiEmbedMode && sensaiEmbedErrorMessage && (
                      <div className="sensai-embed-error" role="alert">
                        <h2>Workflow unavailable</h2>
                        <p>{sensaiEmbedErrorMessage}</p>
                      </div>
                    )}

                    {!sensaiEmbedErrorMessage && (
                      <>

                    <TeacherResetTasksModal
                      show={showTeacherResetModal}
                      handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.resetTask)}
                      prefill={
                        activeTeacherWorkflow === TEACHER_WORKFLOWS.resetTask
                          ? workflowLaunchContext.prefill
                          : null
                      }
                      embedded={isSensaiEmbedMode}
                      onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.resetTask, "Task reset complete.")}
                    />
                    {showTeacherAddChildModal && (
                      <TeacherAddChildModal
                        show={showTeacherAddChildModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.addChild)}
                        schoolid={schoolid}
                        preferredClass={preferredAddChildClass}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.addChild
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        onAssignScreener={handleAssignScreenerBridge}
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.addChild, "Child added.")}
                      />
                    )}
                    {showTeacherRemoveChildModal && (
                      <TeacherRemoveChildModal
                        show={showTeacherRemoveChildModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.removeChild)}
                        teacherid={teacherid}
                        teacherName={name}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.removeChild
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.removeChild, "Child removed.")}
                      />
                    )}
                    {showTeacherCreateClassModal && (
                      <TeacherCreateClassModal
                        show={showTeacherCreateClassModal}
                        handleClose={() =>
                          isSensaiEmbedMode
                            ? closeEmbeddedTeacherWorkflow(TEACHER_WORKFLOWS.createClass)
                            : closeTeacherWorkflow(TEACHER_WORKFLOWS.createClass)
                        }
                        teacherid={teacherid}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.createClass
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        embedded={isSensaiEmbedMode}
                        onAddChildren={handleCreatedClassAddChildren}
                        onWorkflowComplete={(details) =>
                          completeEmbeddedTeacherWorkflow(TEACHER_WORKFLOWS.createClass, details)
                        }
                      />
                    )}
                    {showTeacherRemoveClassModal && (
                      <TeacherRemoveClassModal
                        show={showTeacherRemoveClassModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.removeClass)}
                        schoolid={schoolid}
                        teacherid={teacherid}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.removeClass
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.removeClass, "Class removed.")}
                      />
                    )}
                    {showTeacherRequestAccessModal && (
                      <TeacherRequestAccessModal
                        show={showTeacherRequestAccessModal}
                        handleClose={() => closeTeacherWorkflowForMode(activeTeacherWorkflow)}
                        schoolid={schoolid}
                        countryGrades={schoolCountryGrades}
                        teacherid={teacherid}
                        mode={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.requestAccessOtherTeacher
                            ? "otherTeacher"
                            : "self"
                        }
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.requestAccess ||
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.requestAccessOtherTeacher
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        onOpenOppositeFlow={handleRequestAccessOppositeFlowBridge}
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(activeTeacherWorkflow, "Access request sent.")}
                      />
                    )}
                    {showTeacherSwapResultsModal && (
                      <TeacherSwapResultsModal
                        show={showTeacherSwapResultsModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.swapStudentsResults)}
                        schoolid={schoolid}
                        countryGrades={schoolCountryGrades}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.swapStudentsResults
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        onReturnToResults={handleSwapResultsReturnBridge}
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.swapStudentsResults, "Student result workflow complete.")}
                      />
                    )}
                    {showTeacherFixDuplicateChildModal && (
                      <TeacherFixDuplicateChildModal
                        show={showTeacherFixDuplicateChildModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.fixDuplicateChild)}
                        schoolid={schoolid}
                        countryGrades={schoolCountryGrades}
                        teacherid={teacherid}
                        teacherName={name}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.fixDuplicateChild
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        onViewStudentResults={handleViewStudentResultsBridge}
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.fixDuplicateChild, "Duplicate child fixed.")}
                      />
                    )}
                    {showTeacherFixDuplicateResultsModal && (
                      <TeacherFixDuplicateResultsModal
                        show={showTeacherFixDuplicateResultsModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.fixDuplicateResults)}
                        schoolid={schoolid}
                        countryGrades={schoolCountryGrades}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.fixDuplicateResults
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        onViewStudentResults={handleViewStudentResultsBridge}
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.fixDuplicateResults, "Duplicate results fixed.")}
                      />
                    )}
                    {showTeacherMoveChildrenModal && (
                      <TeacherMoveChildrenModal
                        show={showTeacherMoveChildrenModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.moveTransferChildren)}
                        schoolid={schoolid}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.moveTransferChildren
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        onAssignScreener={handleAssignScreenerBridge}
                        onAddMissingChild={handleMoveChildrenAddMissingChild}
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.moveTransferChildren, "Children moved.")}
                      />
                    )}
                    {showTeacherRemoveColleagueAccessModal && (
                      <TeacherRemoveColleagueAccessModal
                        show={showTeacherRemoveColleagueAccessModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.removeColleagueAccess)}
                        schoolid={schoolid}
                        currentTeacherId={teacherid}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.removeColleagueAccess
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        onRequestAccessForTeacher={(prefill) =>
                          openTeacherWorkflowBridge(TEACHER_WORKFLOWS.requestAccessOtherTeacher, prefill)
                        }
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.removeColleagueAccess, "Colleague access removed.")}
                      />
                    )}
                    {showRemoveTeacherFromSchoolModal && (
                      <RemoveTeacherFromSchoolModal
                        show={showRemoveTeacherFromSchoolModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.removeTeacherFromSchool)}
                        schoolid={schoolid}
                        countryGrades={schoolCountryGrades}
                        currentTeacherId={teacherid}
                        currentTeacherName={name}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.removeTeacherFromSchool
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.removeTeacherFromSchool, "Teacher removal complete.")}
                      />
                    )}
                    {showUpdateTeacherRolesModal && (
                      <UpdateTeacherRolesModal
                        show={showUpdateTeacherRolesModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.updateTeacherRoles)}
                        schoolid={schoolid}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.updateTeacherRoles
                            ? workflowLaunchContext.prefill
                          : null
                        }
                        onAssignAlpacaLead={(prefill) =>
                          openTeacherWorkflowBridge(TEACHER_WORKFLOWS.assignAlpacaLead, prefill)
                        }
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.updateTeacherRoles, "Teacher roles updated.")}
                      />
                    )}
                    {showTeacherInviteTeacherModal && (
                      <TeacherInviteTeacherModal
                        show={showTeacherInviteTeacherModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.inviteTeacherToPlatform)}
                        schoolid={schoolid}
                        teacherid={teacherid}
                        rollnumber={schoolRollNumber}
                        currentTeacherName={name}
                        onReturnToTeacherDashboard={isSensaiEmbedMode ? null : handleReturnToTD}
                        countryId={schoolCountryId}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.inviteTeacherToPlatform
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.inviteTeacherToPlatform, "Teacher invite workflow complete.")}
                      />
                    )}
                    {showTeacherSendAccountSetupModal && (
                      <TeacherSendAccountSetupModal
                        show={showTeacherSendAccountSetupModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.sendAccountSetupLink)}
                        schoolid={schoolid}
                        rollnumber={schoolRollNumber}
                        currentTeacherName={name}
                        countryId={schoolCountryId}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.sendAccountSetupLink
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.sendAccountSetupLink, "Account setup link sent.")}
                      />
                    )}
                    {showTeacherSendPasswordResetModal && (
                      <TeacherSendPasswordResetModal
                        show={showTeacherSendPasswordResetModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.sendPasswordResetLink)}
                        schoolid={schoolid}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.sendPasswordResetLink
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        onUpdateUserEmail={(prefill) =>
                          openTeacherWorkflowBridge(TEACHER_WORKFLOWS.updateUserEmail, prefill)
                        }
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.sendPasswordResetLink, "Password reset link sent.")}
                      />
                    )}
                    {showTeacherUpdateUserEmailModal && (
                      <TeacherUpdateUserEmailModal
                        show={showTeacherUpdateUserEmailModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.updateUserEmail)}
                        schoolid={schoolid}
                        currentTeacherId={teacherid}
                        currentTeacherName={name}
                        currentTeacherEmail={teacherEmail}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.updateUserEmail
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        onSendPasswordReset={(prefill) =>
                          openTeacherWorkflowBridge(TEACHER_WORKFLOWS.sendPasswordResetLink, prefill)
                        }
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.updateUserEmail, "Email update request sent.")}
                      />
                    )}
                    {showTeacherRenameClassModal && (
                      <TeacherRenameClassModal
                        show={showTeacherRenameClassModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.renameClass)}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.renameClass
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.renameClass, "Class renamed.")}
                      />
                    )}
                    {showTeacherAssignAlpacaLeadModal && (
                      <TeacherAssignAlpacaLeadModal
                        show={showTeacherAssignAlpacaLeadModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.assignAlpacaLead)}
                        schoolid={schoolid}
                        currentTeacherId={teacherid}
                        currentTeacherName={name}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.assignAlpacaLead
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        onSendWhatsAppInvite={(prefill) =>
                          openTeacherWorkflowBridge(TEACHER_WORKFLOWS.sendWhatsappGroupInvite, prefill)
                        }
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.assignAlpacaLead, "ALPACA Lead assignment complete.")}
                      />
                    )}
                    {showTeacherAssignScreenerModal && (
                      <TeacherAssignScreenerModal
                        show={showTeacherAssignScreenerModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.assignScreener)}
                        schoolid={schoolid}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.assignScreener
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        onViewQrCodes={handleViewQrCodesBridge}
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.assignScreener, "Screener assignment complete.")}
                      />
                    )}
                    {showTeacherExtendTrialModal && (
                      <TeacherExtendTrialModal
                        show={showTeacherExtendTrialModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.extendTrial)}
                        schoolid={schoolid}
                        onReturnToTeacherDashboard={isSensaiEmbedMode ? null : handleReturnToTD}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.extendTrial
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.extendTrial, "Trial extension request sent.")}
                      />
                    )}
                    {showTeacherRestoreChildResultsModal && (
                      <TeacherRestoreChildResultsModal
                        show={showTeacherRestoreChildResultsModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.restoreChildResults)}
                        schoolid={schoolid}
                        countryGrades={schoolCountryGrades}
                        teacherid={teacherid}
                        teacherName={name}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.restoreChildResults
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        onViewStudentResults={handleViewStudentResultsBridge}
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.restoreChildResults, "Restore child results workflow complete.")}
                      />
                    )}
                    {showTeacherWhatsAppInviteModal && (
                      <TeacherWhatsAppInviteModal
                        show={showTeacherWhatsAppInviteModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.sendWhatsappGroupInvite)}
                        schoolid={schoolid}
                        onReturnToTeacherDashboard={isSensaiEmbedMode ? null : handleReturnToTD}
                        prefill={
                          activeTeacherWorkflow === TEACHER_WORKFLOWS.sendWhatsappGroupInvite
                            ? workflowLaunchContext.prefill
                            : null
                        }
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.sendWhatsappGroupInvite, "WhatsApp invite request sent.")}
                      />
                    )}
                    {showTeacherProvideLoginBypassModal && (
                      <TeacherProvideLoginBypassModal
                        show={showTeacherProvideLoginBypassModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.provideLoginBypass)}
                        schoolid={schoolid}
                        countryGrades={schoolCountryGrades}
                        teacherid={teacherid}
                        teacherName={name}
                        teacherEmail={teacherEmail}
                        prefill={workflowLaunchContext.prefill}
                        onAssignScreener={handleAssignScreenerBridge}
                        onViewScreenerGuidance={(prefill) =>
                          openTeacherWorkflowBridge(TEACHER_WORKFLOWS.screeningGuidanceResources, prefill)
                        }
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.provideLoginBypass, "Login bypass workflow complete.")}
                      />
                    )}
                    {showTeacherActivateTeacherAccountModal && (
                      <TeacherActivateTeacherAccountModal
                        show={showTeacherActivateTeacherAccountModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.activateTeacherAccount)}
                        schoolid={schoolid}
                        rollnumber={schoolRollNumber}
                        currentTeacherName={name}
                        countryId={schoolCountryId}
                        prefill={workflowLaunchContext.prefill}
                        onSendAccountSetup={(prefill) =>
                          openTeacherWorkflowBridge(TEACHER_WORKFLOWS.sendAccountSetupLink, prefill)
                        }
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.activateTeacherAccount, "Teacher account activation complete.")}
                      />
                    )}
                    {showTeacherMergeClassesModal && (
                      <TeacherMergeClassesModal
                        show={showTeacherMergeClassesModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.mergeClasses)}
                        schoolid={schoolid}
                        countryGrades={schoolCountryGrades}
                        teacherid={teacherid}
                        prefill={workflowLaunchContext.prefill}
                        onReturnToTeacherDashboard={isSensaiEmbedMode ? null : handleMergeClassesReturnToTeacherDashboard}
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.mergeClasses, "Classes merged.")}
                      />
                    )}
                    {showTeacherRemoveTeacherAssignmentModal && (
                      <TeacherRemoveTeacherAssignmentModal
                        show={showTeacherRemoveTeacherAssignmentModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.removeTeacherAssignment)}
                        schoolid={schoolid}
                        countryGrades={schoolCountryGrades}
                        teacherid={teacherid}
                        currentTeacherName={name}
                        prefill={workflowLaunchContext.prefill}
                        onRequestAccessForTeacher={(prefill) =>
                          openTeacherWorkflowBridge(TEACHER_WORKFLOWS.requestAccessOtherTeacher, prefill)
                        }
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.removeTeacherAssignment, "Teacher assignment removed.")}
                      />
                    )}
                    {showTeacherEscalateTechnicalIssueModal && (
                      <TeacherEscalateTechnicalIssueModal
                        show={showTeacherEscalateTechnicalIssueModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.escalateTechnicalIssue)}
                        schoolid={schoolid}
                        countryGrades={schoolCountryGrades}
                        teacherName={name}
                        teacherEmail={teacherEmail}
                        onOpenGuidance={(prefill) =>
                          openTeacherWorkflowBridge(TEACHER_WORKFLOWS.screeningGuidanceResources, prefill)
                        }
                        onReturnToTeacherDashboard={isSensaiEmbedMode ? null : handleReturnToTD}
                        prefill={workflowLaunchContext.prefill}
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.escalateTechnicalIssue, "Technical issue escalated.")}
                      />
                    )}
                    {showTeacherMakeResultsVisibleModal && (
                      <TeacherMakeResultsVisibleModal
                        show={showTeacherMakeResultsVisibleModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.makeResultsVisible)}
                        schoolid={schoolid}
                        countryGrades={schoolCountryGrades}
                        teacherid={teacherid}
                        teacherName={name}
                        prefill={workflowLaunchContext.prefill}
                        onGoToClassList={handleGoToClassListBridge}
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.makeResultsVisible, "Results visibility request sent.")}
                      />
                    )}
                    {showTeacherResolveLoginIssueModal && (
                      <TeacherResolveLoginIssueModal
                        show={showTeacherResolveLoginIssueModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.resolveLoginIssue)}
                        schoolid={schoolid}
                        prefill={workflowLaunchContext.prefill}
                        onUpdateUserEmail={(prefill) =>
                          openTeacherWorkflowBridge(TEACHER_WORKFLOWS.updateUserEmail, prefill)
                        }
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.resolveLoginIssue, "Login issue workflow complete.")}
                      />
                    )}
                    {showTeacherRenameUserModal && (
                      <TeacherRenameUserModal
                        show={showTeacherRenameUserModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.renameUser)}
                        schoolid={schoolid}
                        currentTeacherName={name}
                        currentTeacherEmail={teacherEmail}
                        prefill={workflowLaunchContext.prefill}
                        onUpdateUserEmail={(prefill) =>
                          openTeacherWorkflowBridge(TEACHER_WORKFLOWS.updateUserEmail, prefill)
                        }
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.renameUser, "Teacher rename request sent.")}
                      />
                    )}
                    {showTeacherOfferToAddTeacherModal && (
                      <TeacherOfferToAddTeacherModal
                        show={showTeacherOfferToAddTeacherModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.offerToAddTeacher)}
                        schoolid={schoolid}
                        teacherid={teacherid}
                        rollnumber={schoolRollNumber}
                        currentTeacherName={name}
                        countryId={schoolCountryId}
                        prefill={workflowLaunchContext.prefill}
                        onInviteTeacher={(prefill) =>
                          openTeacherWorkflowBridge(TEACHER_WORKFLOWS.inviteTeacherToPlatform, prefill)
                        }
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.offerToAddTeacher, "Add teacher workflow complete.")}
                      />
                    )}
                    {showTeacherOfferMeetingModal && (
                      <TeacherOfferMeetingModal
                        show={showTeacherOfferMeetingModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.offerMeeting)}
                        schoolid={schoolid}
                        teacherName={name}
                        teacherEmail={teacherEmail}
                        onOpenGuidance={(prefill) =>
                          openTeacherWorkflowBridge(TEACHER_WORKFLOWS.screeningGuidanceResources, prefill)
                        }
                        onReturnToTeacherDashboard={isSensaiEmbedMode ? null : handleReturnToTD}
                        prefill={workflowLaunchContext.prefill}
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.offerMeeting, "Meeting request sent.")}
                      />
                    )}
                    {showTeacherEscalateFeatureRequestModal && (
                      <TeacherEscalateFeatureRequestModal
                        show={showTeacherEscalateFeatureRequestModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.escalateFeatureRequest)}
                        schoolid={schoolid}
                        teacherName={name}
                        teacherEmail={teacherEmail}
                        onOpenGuidance={(prefill) =>
                          openTeacherWorkflowBridge(TEACHER_WORKFLOWS.screeningGuidanceResources, prefill)
                        }
                        onReturnToTeacherDashboard={isSensaiEmbedMode ? null : handleReturnToTD}
                        prefill={workflowLaunchContext.prefill}
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.escalateFeatureRequest, "Feature request sent.")}
                      />
                    )}
                    {showTeacherRequestEarlyPlatformAccessModal && (
                      <TeacherRequestEarlyPlatformAccessModal
                        show={showTeacherRequestEarlyPlatformAccessModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.requestEarlyPlatformAccess)}
                        schoolid={schoolid}
                        teacherName={name}
                        teacherEmail={teacherEmail}
                        prefill={workflowLaunchContext.prefill}
                        onViewScreenerGuidance={(prefill) =>
                          openTeacherWorkflowBridge(TEACHER_WORKFLOWS.screeningGuidanceResources, prefill)
                        }
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.requestEarlyPlatformAccess, "Platform access request sent.")}
                      />
                    )}
                    {showTeacherRequestInvoiceModal && (
                      <TeacherRequestInvoiceModal
                        show={showTeacherRequestInvoiceModal}
                        handleClose={() =>
                          isSensaiEmbedMode
                            ? closeEmbeddedTeacherWorkflow(TEACHER_WORKFLOWS.requestInvoice)
                            : closeTeacherWorkflow(TEACHER_WORKFLOWS.requestInvoice)
                        }
                        schoolid={schoolid}
                        teacherEmail={teacherEmail}
                        onReturnToTeacherDashboard={isSensaiEmbedMode ? null : handleReturnToTD}
                        prefill={workflowLaunchContext.prefill}
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={(details) =>
                          completeEmbeddedTeacherWorkflow(TEACHER_WORKFLOWS.requestInvoice, details)
                        }
                      />
                    )}
                    {showTeacherTrialAccessStatusModal && (
                      <TeacherTrialAccessStatusModal
                        show={showTeacherTrialAccessStatusModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.trialAccessStatus)}
                        schoolid={schoolid}
                        onOpenGuidance={(prefill) =>
                          openTeacherWorkflowBridge(TEACHER_WORKFLOWS.screeningGuidanceResources, prefill)
                        }
                        onOpenPurchaseDetails={(prefill) =>
                          openTeacherWorkflowBridge(TEACHER_WORKFLOWS.requestInvoice, {
                            recipientEmail: teacherEmail,
                            ...prefill
                          })
                        }
                        onOpenExtendTrial={(prefill) =>
                          openTeacherWorkflowBridge(TEACHER_WORKFLOWS.extendTrial, prefill)
                        }
                        onReturnToTeacherDashboard={isSensaiEmbedMode ? null : handleReturnToTD}
                        prefill={workflowLaunchContext.prefill}
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.trialAccessStatus, "Trial access request sent.")}
                      />
                    )}
                    {showTeacherFixDuplicateChildResultsModal && (
                      <TeacherFixDuplicateChildResultsModal
                        show={showTeacherFixDuplicateChildResultsModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.fixDuplicateChildResults)}
                        schoolid={schoolid}
                        countryGrades={schoolCountryGrades}
                        prefill={workflowLaunchContext.prefill}
                        onViewResults={handleViewStudentResultsBridge}
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.fixDuplicateChildResults, "Result issue review request sent.")}
                      />
                    )}
                    {showTeacherAladdinExportModal && (
                      <TeacherAladdinExportModal
                        show={showTeacherAladdinExportModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.exportAssessmentData)}
                        schoolid={schoolid}
                        countryGrades={schoolCountryGrades}
                        teacherid={teacherid}
                        teacherName={name}
                        teacherEmail={teacherEmail}
                        prefill={workflowLaunchContext.prefill}
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.exportAssessmentData, "Assessment export request sent.")}
                      />
                    )}
                    {showTeacherScreeningGuidanceResourcesModal && (
                      <TeacherScreeningGuidanceResourcesModal
                        show={showTeacherScreeningGuidanceResourcesModal}
                        handleClose={() => closeTeacherWorkflowForMode(TEACHER_WORKFLOWS.screeningGuidanceResources)}
                        schoolid={schoolid}
                        countryId={schoolCountryId}
                        teacherEmail={teacherEmail}
                        onReturnToTeacherDashboard={isSensaiEmbedMode ? null : handleReturnToTD}
                        prefill={workflowLaunchContext.prefill}
                        embedded={isSensaiEmbedMode}
                        onWorkflowComplete={createEmbeddedCompleteHandler(TEACHER_WORKFLOWS.screeningGuidanceResources, "Guidance workflow complete.")}
                      />
                    )}
                      </>
                    )}
                  </div>
                ) : (
                  <>
                <div className="dashboard-header">
                  <h2 className="dashboard-title">ALPACA Test Dashboard</h2>
                  <p className="dashboard-subtitle">
                    Manage your educational platform efficiently
                  </p>
                </div>

                {/* Featured Admin Cards */}
                <div className="featured-cards-section">
                  <div className="admin-cards-grid featured-grid">
                    {allFeaturedCards.map((card, index) => (
                      <AdminCard key={index} item={card} />
                    ))}
                  </div>
                </div>

                {/* ✅ Other Admin Sections - Only show for alpaca-staff */}
                {adminSections.map((section, sectionIndex) => (
                  <div key={sectionIndex} className="admin-section">
                    <h3 className="section-title">{section.title}</h3>
                    <div className="admin-cards-grid">
                      {section.items.map((item, itemIndex) => (
                        <AdminCard key={itemIndex} item={item} />
                      ))}
                    </div>
                  </div>
                ))}
                  </>
                )}
              </div>
            )}
          </Col>
        </Row>
      </Container>

      {isPortrait && <OrientationPrompt />}
    </div>
  );
}

export default MasterDashboard;
